import e, { Children as t, createContext as n, useCallback as r, useContext as i, useEffect as a, useLayoutEffect as o, useMemo as s, useReducer as c, useRef as l, useState as u } from "react";
import { Fragment as d, jsx as f, jsxs as p } from "react/jsx-runtime";
import { Editor as m, Editor as h, Element as g, Element as _, Node as v, Node as y, Path as b, Point as x, Range as ee, Range as S, Text as te, Text as C, Transforms as w, Transforms as T, createEditor as E } from "slate";
import { Editable as ne, ReactEditor as D, Slate as O, useFocused as re, useSelected as k, useSlate as A, useSlateSelection as j, useSlateSelector as ie, useSlateStatic as M, withReact as N } from "slate-react";
import * as P from "yjs";
import { CursorEditor as F, YjsEditor as I, relativePositionToSlatePoint as ae, slatePointToRelativePosition as oe, withCursors as se, withYHistory as ce, withYjs as le } from "@slate-yjs/core";
import { withHistory as ue } from "slate-history";
import { useRemoteCursorOverlayPositions as de } from "@slate-yjs/react";
import { createPortal as L } from "react-dom";
//#region \0rolldown/runtime.js
var fe = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports);
//#endregion
//#region lib/utils/injectStyles.ts
if (typeof document < "u") {
	let e = "textbit-keyframes";
	if (!document.getElementById(e)) {
		let t = document.createElement("style");
		t.id = e, t.textContent = [
			"@keyframes block-caret-blink{0%,100%{opacity:1}50%{opacity:0}}",
			"[data-state=\"active\"] .tb-focus-ring{outline:1px solid currentColor;outline-offset:4px;border-radius:var(--tb-focus-ring-radius,5px);opacity:0.3}",
			".tb-newline{background:var(--tb-newline-background,color-mix(in srgb,currentColor 18%,transparent));box-shadow:inset 0 0 0 1px var(--tb-newline-border,color-mix(in srgb,currentColor 45%,transparent));border-radius:var(--tb-newline-radius,2px)}",
			".tb-newline::before{content:var(--tb-newline-symbol,'\\21B5');opacity:0.6;user-select:none;-webkit-user-select:none;pointer-events:none}"
		].join(""), document.head.appendChild(t);
	}
}
var pe = n({
	verbose: !1,
	readOnly: !1,
	collaborative: !1,
	dir: "ltr",
	lang: "en",
	debounce: 250,
	spellcheckDebounce: 1250,
	placeholder: "",
	placeholders: "none",
	stats: {
		full: {
			words: 0,
			characters: 0
		},
		short: {
			words: 0,
			characters: 0
		}
	},
	dispatch: () => {}
}), me = (e, t) => {
	let { stats: n } = t, r = {};
	return n && (r.stats = n), {
		...e,
		...r
	};
};
function he({ children: e, verbose: t, readOnly: n, collaborative: r, dir: i, lang: a, debounce: o, spellcheckDebounce: s, placeholder: l, placeholders: u }) {
	let [d, p] = c(me, {
		verbose: t ?? !1,
		readOnly: n ?? !1,
		collaborative: r ?? !1,
		dir: i ?? "ltr",
		lang: a ?? "en",
		debounce: o ?? 250,
		spellcheckDebounce: s ?? 1250,
		placeholder: l ?? "",
		placeholders: u ?? "none",
		stats: {
			full: {
				words: 0,
				characters: 0
			},
			short: {
				words: 0,
				characters: 0
			}
		},
		dispatch: () => {}
	});
	return /* @__PURE__ */ f(pe.Provider, {
		value: {
			...d,
			dispatch: p
		},
		children: e
	});
}
//#endregion
//#region lib/contexts/PluginRegistry/lib/registerPlugin.ts
function ge(e, t, n) {
	n?.verbose && console.info(`Registering plugin ${t.name}`);
	let r = [...e], i = r.findIndex((e) => e.name === t.name);
	return i === -1 ? r.push(t) : (console.warn(`%c Overriding already registered plugin ${t.name}`), r[i] = t), r;
}
//#endregion
//#region lib/contexts/PluginRegistry/lib/registerComponents.ts
var _e = (e, t, n, r, i) => {
	let a = /* @__PURE__ */ new Map();
	return e.forEach((e, t) => {
		a.set(t, e);
	}), ve(a, t, n, r || {}, i || {}), a;
}, ve = (e, t, n, r, i) => {
	e.has(t) && r.verbose && console.info(`%c Component ${t} render function overrided by new render component with the same type`), n.class || console.warn(`Component ${t} is missing a class, using "text" as fallback type`), e.set(t, {
		type: t,
		class: n.class || "text",
		componentEntry: n,
		parent: r?.parent || null,
		pluginOptions: i || /* @__PURE__ */ new Map()
	});
	let { children: a = [] } = n;
	a.forEach((a) => {
		if (!a.type) throw Error(`Child component of ${t} is missing mandatory type`);
		ve(e, `${t}/${a.type}`, a, {
			verbose: r.verbose,
			parent: n
		}, i);
	});
}, ye = (/* @__PURE__ */ fe(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	for (var t = typeof window < "u" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), n = {
		alt: "altKey",
		control: "ctrlKey",
		meta: "metaKey",
		shift: "shiftKey"
	}, r = {
		add: "+",
		break: "pause",
		cmd: "meta",
		command: "meta",
		ctl: "control",
		ctrl: "control",
		del: "delete",
		down: "arrowdown",
		esc: "escape",
		ins: "insert",
		left: "arrowleft",
		mod: t ? "meta" : "control",
		opt: "alt",
		option: "alt",
		return: "enter",
		right: "arrowright",
		space: " ",
		spacebar: " ",
		up: "arrowup",
		win: "meta",
		windows: "meta"
	}, i = {
		backspace: 8,
		tab: 9,
		enter: 13,
		shift: 16,
		control: 17,
		alt: 18,
		pause: 19,
		capslock: 20,
		escape: 27,
		" ": 32,
		pageup: 33,
		pagedown: 34,
		end: 35,
		home: 36,
		arrowleft: 37,
		arrowup: 38,
		arrowright: 39,
		arrowdown: 40,
		insert: 45,
		delete: 46,
		meta: 91,
		numlock: 144,
		scrolllock: 145,
		";": 186,
		"=": 187,
		",": 188,
		"-": 189,
		".": 190,
		"/": 191,
		"`": 192,
		"[": 219,
		"\\": 220,
		"]": 221,
		"'": 222
	}, a = 1; a < 20; a++) i["f" + a] = 111 + a;
	function o(e, t, n) {
		t && !("byKey" in t) && (n = t, t = null), Array.isArray(e) || (e = [e]);
		var r = e.map(function(e) {
			return s(e, t);
		}), i = function(e) {
			return r.some(function(t) {
				return c(t, e);
			});
		};
		return n == null ? i : i(n);
	}
	function s(e, t) {
		var a = t && t.byKey, o = {};
		e = e.replace("++", "+add");
		var s = e.split("+"), c = s.length;
		for (var d in n) o[n[d]] = !1;
		var f = !0, p = !1, m = void 0;
		try {
			for (var h = s[Symbol.iterator](), g; !(f = (g = h.next()).done); f = !0) {
				var _ = g.value, v = _.endsWith("?") && _.length > 1;
				v && (_ = _.slice(0, -1));
				var y = u(_), b = n[y];
				if (_.length > 1 && !b && !r[_] && !i[y]) throw TypeError("Unknown modifier: \"" + _ + "\"");
				(c === 1 || !b) && (a ? o.key = y : o.which = l(_)), b && (o[b] = !v || null);
			}
		} catch (e) {
			p = !0, m = e;
		} finally {
			try {
				!f && h.return && h.return();
			} finally {
				if (p) throw m;
			}
		}
		return o;
	}
	function c(e, t) {
		for (var n in e) {
			var r = e[n], i = void 0;
			if (r != null && (i = n === "key" && t.key != null ? t.key.toLowerCase() : n === "which" ? r === 91 && t.which === 93 ? 91 : t.which : t[n], (i != null || r !== !1) && i !== r)) return !1;
		}
		return !0;
	}
	function l(e) {
		return e = u(e), i[e] || e.toUpperCase().charCodeAt(0);
	}
	function u(e) {
		return e = e.toLowerCase(), e = r[e] || e, e;
	}
	e.isHotkey = o;
})))(), be = (e) => {
	let t = [];
	return e.filter((e) => Array.isArray(e.actions) && e.actions.length).forEach((e) => {
		e.actions?.forEach((n) => {
			let r = typeof n.hotkey == "string" ? (0, ye.isHotkey)(n.hotkey) : () => !1;
			t.push({
				plugin: e,
				isHotkey: r,
				...n,
				name: `${e.name}/${n.name}`
			});
		});
	}), t;
}, R = {
	isLeafPlugin: (e) => e?.class === "leaf",
	isElementPlugin: (e) => e?.class !== "leaf"
}, xe = () => ({
	plugins: [],
	components: /* @__PURE__ */ new Map(),
	actions: [],
	verbose: !1,
	dispatch: () => {}
}), Se = n(xe()), Ce = (e, t) => {
	let { action: n, plugin: r } = t;
	return n === "delete" ? (console.warn("Deleting plugins from plugin registry not implemented"), e) : {
		...e,
		...Te(e, r, { verbose: e.verbose })
	};
};
function we({ children: e, verbose: t, plugins: n }) {
	let r = Ee(xe(), n, { verbose: t }), [i, a] = c(Ce, {
		...xe(),
		...r
	});
	return /* @__PURE__ */ f(Se.Provider, {
		value: {
			...i,
			dispatch: a
		},
		children: e
	});
}
function Te(e, t, n) {
	let r = ge(e.plugins, t, n);
	return {
		plugins: r,
		actions: be(r),
		components: R.isElementPlugin(t) && t?.componentEntry ? _e(e.components, t.componentEntry?.type || t.name, t.componentEntry, n, t.options) : e.components
	};
}
function Ee(e, t, n) {
	return t.forEach((t) => {
		e.plugins = ge(e.plugins, t, n), e.actions = be(e.plugins), R.isElementPlugin(t) && t?.componentEntry && (e.components = _e(e.components, t.componentEntry?.type || t.name, t.componentEntry, n, t.options));
	}), { ...e };
}
//#endregion
//#region lib/utils/textbit-element.ts
var z = {
	isTextLeaf: (e) => C.isText(e),
	..._,
	isBlock: (e) => _.isAncestor(e) && _.isElement(e) && e.class === "block",
	isText: (e) => _.isElement(e) && e.class === "text",
	isVoid: (e) => _.isElement(e) && e.class === "void",
	isInline: (e) => _.isElement(e) && e.class === "inline",
	isOfType: (e, t) => _.isElement(e) && e?.type === t,
	hasId: (e, t) => _.isElement(e) && e?.id === t
}, B = {
	...h,
	position: (e) => {
		let { selection: t } = e;
		if (!t) return -1;
		let n = h.unhangRange(e, t);
		return n && n.anchor.path.length ? n.anchor.path[0] : -1;
	},
	length: (e) => Array.from(h.nodes(e, {
		at: [],
		mode: "highest",
		match: (e) => _.isElement(e)
	})).length,
	parents: (e) => h.nodes(e, {
		at: [],
		mode: "highest",
		match: (e) => _.isElement(e)
	}),
	selectedTextEntries: (e) => {
		if (!S.isRange(e.selection)) return [];
		let t = h.nodes(e, {
			at: e.selection,
			match: (e) => C.isText(e)
		});
		return Array.from(t);
	},
	includes: (e, t) => {
		let { selection: n } = e;
		if (!n) return !1;
		let [r] = Array.from(h.nodes(e, {
			at: h.unhangRange(e, n),
			match: (e) => !h.isEditor(e) && _.isElement(e) && e.type === t
		}));
		return !!r;
	},
	getSelectedText: (e, t) => {
		let n = t || h.unhangRange(e, e.selection);
		return h.string(e, n);
	},
	replaceStringAtPosition: (e, t, n) => {
		if (!e.selection) return;
		let r = e.selection.anchor, [i] = h.node(e, r.path);
		if (!C.isText(i)) return;
		let a = r.offset - t.length;
		a < 0 && (a = 0);
		let o = -1, s = -1;
		for (; (a = i.text.indexOf(t, a)) !== -1;) {
			if (r.offset >= a && r.offset <= a + t.length) {
				o = a, s = a + t.length;
				break;
			}
			a += 1;
		}
		if (o === -1) return;
		let c = {
			anchor: {
				path: r.path,
				offset: o
			},
			focus: {
				path: r.path,
				offset: s
			}
		};
		T.insertText(e, n, { at: c });
	},
	insertAt(e, t, n) {
		(Array.isArray(n) ? n : [n]).length && T.insertNodes(e, n, { at: [t] });
	},
	hasText(e) {
		for (let [t] of e) for (let e of y.texts(t)) if (e[0].text.trim() !== "") return !0;
		return !1;
	},
	convertToTextNode(e, t, n = void 0) {
		if (!e.selection) return;
		let r = Array.from(h.nodes(e, {
			mode: "highest",
			at: h.unhangRange(e, e.selection),
			match: (e) => !h.isEditor(e)
		}));
		r.length && h.withoutNormalizing(e, () => {
			for (let i = 0; i < r.length; i++) {
				let [a, o] = r[i];
				if (!z.isOfType(a, "core/text") && z.isText(a)) {
					let r = a.id;
					T.removeNodes(e, { at: o });
					let i = y.string(a);
					T.insertNodes(e, {
						id: r,
						class: "text",
						type: t,
						properties: n ? { role: n } : {},
						children: [{ text: i }]
					}, { at: o }), e.select({
						anchor: {
							path: o.concat(0),
							offset: 0
						},
						focus: {
							path: o.concat(0),
							offset: 0
						}
					});
				} else z.isOfType(a, "core/text") && T.setNodes(e, {
					type: "core/text",
					properties: n ? { role: n } : {}
				}, { at: o });
			}
		});
	}
}, De = () => ({
	class: "text",
	name: "core/text",
	componentEntry: {
		class: "text",
		component: Oe,
		placeholder: "¶"
	},
	actions: [{
		name: "set-text",
		title: "Text",
		handler: ({ editor: e }) => {
			B.convertToTextNode(e, "core/text");
		},
		visibility: (e) => [
			e.type === "core/text",
			!0,
			e.type === "core/text" && !e?.properties?.role
		]
	}]
});
function Oe(e) {
	return /* @__PURE__ */ f(d, { children: e.children });
}
//#endregion
//#region lib/components/core/Leafs/index.tsx
var ke = () => ({
	class: "leaf",
	name: "core/bold",
	actions: [{
		name: "toggle-bold",
		tool: () => /* @__PURE__ */ f("div", {
			style: { fontWeight: "bold" },
			children: "B"
		}),
		hotkey: "mod+b",
		handler: () => !0
	}],
	getStyle: () => ({ fontWeight: "bold" })
}), Ae = () => ({
	class: "leaf",
	name: "core/italic",
	actions: [{
		name: "toggle-italic",
		tool: () => /* @__PURE__ */ f("div", {
			style: { fontStyle: "italic" },
			children: "I"
		}),
		hotkey: "mod+i",
		handler: () => !0
	}],
	getStyle: () => ({ fontStyle: "italic" })
}), je = () => ({
	class: "leaf",
	name: "core/underline",
	actions: [{
		name: "toggle-underline",
		hotkey: "mod+u",
		tool: () => /* @__PURE__ */ f("div", {
			style: { textDecoration: "underline" },
			children: "U"
		}),
		handler: () => !0
	}],
	getStyle: () => ({ textDecoration: "underline" })
}), Me = () => ({
	class: "generic",
	name: "navigation",
	actions: [{
		name: "move-text-up",
		hotkey: "mod+option+up",
		handler: ({ editor: e }) => {
			let t = B.position(e);
			t < 1 || T.moveNodes(e, {
				at: [t],
				to: [t - 1]
			});
		}
	}, {
		name: "move-text-down",
		hotkey: "mod+option+down",
		handler: ({ editor: e }) => {
			let t = B.position(e), n = B.length(e);
			t < 0 || t + 1 === n || T.moveNodes(e, {
				at: [t],
				to: [t + 1]
			});
		}
	}]
});
//#endregion
//#region lib/utils/modifier.ts
function Ne() {
	if (typeof navigator > "u") return !1;
	let e = navigator, t = e.userAgentData?.platform || e.platform || e.userAgent || "";
	return /\bmac/i.test(t);
}
var Pe = Ne(), Fe = {
	up: "↑",
	down: "↓",
	right: "→",
	left: "←"
}, Ie = {
	mod: "⌘",
	shift: "⇧",
	ctrl: "⌃",
	control: "⌃",
	alt: "⌥",
	opt: "⌥",
	option: "⌥"
}, Le = {
	mod: "Ctrl",
	ctrl: "Ctrl",
	control: "Ctrl",
	shift: "Shift",
	alt: "Alt",
	opt: "Alt",
	option: "Alt"
};
function Re(e, t = Pe) {
	return e ? e.split("+").map((e) => ze(e, t)).filter(Boolean).join(t ? "" : "+") : "";
}
function ze(e, t) {
	let n = e.toLowerCase();
	return ((t ? Ie : Le)[n] ?? Fe[n]) || (e.length === 1 ? e.toUpperCase() : e);
}
//#endregion
//#region lib/components/core/NonBreakingSpace.tsx
var Be = "\xA0", Ve = () => ({
	class: "generic",
	name: "non-breaking-space",
	actions: [{
		name: "insert",
		hotkey: Ne() ? void 0 : "ctrl+shift+space",
		handler: ({ editor: e, event: t }) => {
			t?.preventDefault(), e.insertText(Be);
		}
	}]
}), V = [
	De,
	ke,
	Ae,
	je
], He = [Me, Ve], Ue = {
	menu: void 0,
	spelling: void 0,
	dispatch: () => {}
}, H = n(Ue), We = (e, t) => {
	let { menu: n, spelling: r } = t, i = {};
	return i.menu = n, i.spelling = r, {
		...e,
		...i
	};
};
function Ge({ children: e }) {
	let [t, n] = c(We, { ...Ue }), r = {
		...t,
		dispatch: n
	};
	return /* @__PURE__ */ f(H.Provider, {
		value: r,
		children: e
	});
}
//#endregion
//#region lib/contexts/SelectionBoundsContext.tsx
var Ke = n(void 0);
//#endregion
//#region lib/contexts/SelectionBoundsProvider.tsx
function qe({ children: e }) {
	let t = l(void 0), n = l(/* @__PURE__ */ new Set()), i = M(), o = r((e) => (n.current.add(e), e(t.current), () => {
		n.current.delete(e);
	}), []), s = r(() => {
		n.current.forEach((e) => {
			e(t.current);
		});
	}, []), c = r(() => {
		let e = window.getSelection();
		if (!e || e.rangeCount === 0) {
			t.current = void 0, s();
			return;
		}
		let n = e.getRangeAt(0), { top: r, right: a, bottom: o, left: c, width: l, height: u, x: d, y: f } = n.getBoundingClientRect(), p;
		if (i && D.isFocused(i) && i.selection) try {
			let [e] = h.nodes(i, {
				at: i.selection,
				match: (e) => _.isElement(e) && h.isBlock(i, e)
			});
			if (e) {
				let [t] = e;
				p = D.toDOMNode(i, t).getBoundingClientRect();
			}
		} catch (e) {
			console.warn("Failed to get Slate element bounds:", e);
		}
		let m = {
			top: r,
			right: a,
			bottom: o,
			left: c,
			width: l,
			height: u,
			x: d,
			y: f,
			isCollapsed: n.collapsed,
			box: p
		};
		JSON.stringify(t.current) !== JSON.stringify(m) && (t.current = m, s());
	}, [s, i]);
	a(() => {
		c();
		let e = () => {
			requestAnimationFrame(() => {
				c();
			});
		}, t = () => {
			c();
		};
		return document.addEventListener("selectionchange", e, {
			capture: !0,
			passive: !0
		}), window.addEventListener("scroll", t, {
			capture: !0,
			passive: !0
		}), () => {
			document.removeEventListener("selectionchange", e, { capture: !0 }), window.removeEventListener("scroll", t, { capture: !0 });
		};
	}, [c]);
	let u = {
		boundsRef: t,
		subscribe: o
	};
	return /* @__PURE__ */ f(Ke.Provider, {
		value: u,
		children: e
	});
}
//#endregion
//#region lib/utils/calculateStats.ts
function Je(e) {
	let t = Array.from(h.nodes(e, {
		at: [],
		match: (e, t) => _.isElement(e) && ["core/text"].includes(e.type || "") && e.properties?.role !== "vignette" && t.length === 1
	}));
	return {
		full: Ye(Array.from(h.nodes(e, {
			at: [],
			match: (e) => _.isElement(e) && ["text"].includes(e.class || "")
		}))),
		short: Ye(t)
	};
}
function Ye(e) {
	let t = 0, n = 0;
	for (let [r] of e) {
		let e = y.string(r).trim();
		t += (e.match(/\p{L}+/gu) || []).length, n += e.length;
	}
	return {
		words: t,
		characters: n
	};
}
//#endregion
//#region lib/utils/debounce.ts
var Xe = (e, t) => {
	let n, r = (...r) => {
		clearTimeout(n), n = setTimeout(() => {
			e(...r);
		}, t);
	};
	return r.force = (...t) => {
		clearTimeout(n), e(...t);
	}, r.cancel = () => {
		clearTimeout(n);
	}, r;
};
//#endregion
//#region lib/with/withLang.ts
function Ze(e, t) {
	return e.lang = t || document?.documentElement?.lang || navigator.language || "en", e;
}
//#endregion
//#region lib/with/withSpeling.ts
function Qe(e, t, n = 6125) {
	let { onChange: r } = e, i = null;
	return e.spellingLookupTable = /* @__PURE__ */ new Map(), e.onSpellcheckComplete = (e) => {
		i = e;
	}, e.spellcheck = Xe(async () => {
		if (!t) return;
		let [n, r, a] = await $e(e, t, e.spellingLookupTable);
		n && r.length > 0 && (e.spellingLookupTable = a, i?.(a, r));
	}, n), e.onChange = (t) => {
		r(t), e.operations.filter((e) => [
			"insert_text",
			"remove_text",
			"split_node",
			"merge_node"
		].includes(e.type)).length && e.spellcheck && e.spellcheck();
	}, e;
}
async function $e(e, t, n) {
	let r = /* @__PURE__ */ new Map(), i = [], a = [];
	for (let t of e.children) {
		if (!_.isElement(t) || !t.id) continue;
		let a = n.get(t.id), o = y.string(t);
		if (!a || a.text !== o) {
			let n = o.trim() === "";
			r.set(t.id, {
				lang: t.lang || e.lang,
				text: o,
				errors: [],
				check: !n
			}), n || i.push(t.id);
		} else r.set(t.id, {
			...a,
			check: !1
		});
	}
	if (!i.length) return [
		!1,
		[],
		r
	];
	let o = await t(Array.from(r.values()).filter((e) => e.check).map((e) => ({
		text: e.text,
		lang: e.lang
	})));
	if (o.length !== i.length) return console.warn("Number of spellchecked texts differ from requested number of texts to spellcheck"), [
		!1,
		[],
		r
	];
	for (let e = 0; e < i.length; e++) {
		let t = i[e], n = r.get(t);
		n && (n.errors = o[e].filter((e) => e?.text && Array.isArray(e?.suggestions)).map((e) => ({
			id: crypto.randomUUID(),
			text: e.text,
			level: e.level,
			suggestions: e.suggestions || []
		})), a.push(t));
	}
	return [
		!0,
		a,
		r
	];
}
//#endregion
//#region lib/with/withTextbitElements.ts
function et(e) {
	let { isInline: t, isBlock: n, isVoid: r } = e;
	return e.isInline = (e) => _.isElement(e) && e.class === "inline" ? !0 : t(e), e.isBlock = (e) => _.isAncestor(e) && _.isElement(e) && e.class === "block" ? !0 : n(e), e.isVoid = (e) => _.isElement(e) && e.class === "void" ? !0 : r(e), e.isTextBlock = (e) => _.isElement(e) && e.class === "text", e.isOfType = (e, t) => _.isElement(e) && e?.type === t, e;
}
//#endregion
//#region lib/utils/pasteToConsumer.ts
function tt(e, t, n) {
	let [r, i] = nt(t, n);
	return typeof r == "function" && new Promise((t) => {
		r({
			input: n,
			editor: e
		}).then((n) => {
			typeof n?.data == "object" && i === n.type ? (rt(e, n.data), t()) : typeof n?.data == "string" && i === "text/plain" ? t(n?.data) : (console.warn("Unexpected output from consumer when handling paste", n), t());
		}).catch((e) => {
			console.warn(e instanceof Error ? e.message : String(e)), t();
		});
	});
}
function nt(e, t) {
	for (let n of e) {
		let [e, r] = n?.consumes({ input: t }) || [!1];
		if (e) return [n.consume, r];
	}
	return [void 0, void 0];
}
function rt(e, t) {
	if (!S.isRange(e.selection)) return;
	let n = h.unhangRange(e, e.selection), r = n && n.anchor.path[0] > 0 ? n.anchor.path[0] : 0, i = y.get(e, [r]);
	_.isElement(i) && (i?.class === "text" && h.string(e, [r]) === "" ? T.removeNodes(e, { at: [r] }) : r++, T.insertNodes(e, t, {
		at: [r],
		select: !0
	}));
}
//#endregion
//#region lib/with/withInsertText.ts
function it(e, t) {
	let { insertText: n } = e, r = t.filter((e) => R.isElementPlugin(e) && !!e.consumer?.consume && !!e.consumer?.consumes).map(({ consumer: e }) => e);
	return e.insertText = (t) => {
		let i = tt(e, r, {
			source: "text",
			type: "text/plain",
			data: t
		});
		if (!(i instanceof Promise)) {
			n(t);
			return;
		}
		i.then((e) => {
			n(typeof e == "string" ? e : t);
		});
	}, e;
}
//#endregion
//#region lib/with/withNormalizeNode.ts
function at(e, t, n) {
	let { normalizeNode: r } = e;
	return e.normalizeNode = (t) => {
		let [i, a] = t;
		if (!_.isElement(i)) return r(t);
		let o = n.get(i.type);
		if (!o) {
			if (a.length === 1 && !i.type && n.has("core/text") && ut(i)) {
				T.setNodes(e, {
					type: "core/text",
					class: "text",
					properties: {}
				}, { at: a });
				return;
			}
			return r(t);
		}
		ot(e, t, o) || (typeof o.componentEntry.constraints?.normalizeNode != "function" || !0 !== o.componentEntry.constraints.normalizeNode(e, t)) && r(t);
	}, e;
}
function ot(e, t, n) {
	let [r, i] = t;
	if (!_.isElement(r)) return !1;
	let a = n.componentEntry.children;
	if (!a || a.length === 0) return !1;
	let o = a.filter((e) => e.constraints?.min !== void 0 || e.constraints?.max !== void 0);
	if (o.length === 0) return !1;
	let s = n.type;
	for (let t of o) {
		let n = t.constraints?.max;
		if (n === void 0) continue;
		let a = st(r, `${s}/${t.type}`);
		if (a.length > n) {
			let t = a[a.length - 1];
			return T.removeNodes(e, { at: [...i, t] }), !0;
		}
	}
	for (let t of o) {
		let n = t.constraints?.min;
		if (n === void 0) continue;
		let o = `${s}/${t.type}`;
		if (st(r, o).length < n) {
			let n = ct(r, a, t);
			return T.insertNodes(e, dt(t, o), { at: [...i, n] }), !0;
		}
	}
	let c = /* @__PURE__ */ new Map();
	a.forEach((e, t) => {
		e.type && c.set(`${s}/${e.type}`, t);
	});
	let l = r.children.map((e) => _.isElement(e) ? c.get(e.type) ?? Infinity : Infinity);
	for (let t = 1; t < l.length; t++) if (l[t] < l[t - 1]) {
		let n = 0;
		for (let e = 0; e < t; e++) {
			if (l[e] >= l[t]) {
				n = e;
				break;
			}
			n = e + 1;
		}
		return T.moveNodes(e, {
			at: [...i, t],
			to: [...i, n]
		}), !0;
	}
	return !1;
}
function st(e, t) {
	let n = [];
	for (let r = 0; r < e.children.length; r++) {
		let i = e.children[r];
		_.isElement(i) && i.type === t && n.push(r);
	}
	return n;
}
function ct(e, t, n) {
	let r = /* @__PURE__ */ new Map();
	t.forEach((e, t) => r.set(e.type, t));
	let i = r.get(n.type) ?? 0, a = 0;
	for (let n = 0; n < e.children.length; n++) {
		let r = e.children[n];
		_.isElement(r) && lt(r.type, t) < i && (a = n + 1);
	}
	return a;
}
function lt(e, t) {
	for (let n = 0; n < t.length; n++) {
		let r = t[n];
		if (r.type && e.endsWith(`/${r.type}`)) return n;
	}
	return Infinity;
}
function ut(e) {
	return e.children.every((e) => !_.isElement(e) || z.isInline(e));
}
function dt(e, t) {
	let n = {
		id: crypto.randomUUID(),
		type: t,
		children: [{ text: "" }]
	};
	switch (e.class) {
		case "void": return {
			...n,
			class: "void"
		};
		case "block": return {
			...n,
			class: "block"
		};
		case "text": return {
			...n,
			class: "text",
			properties: {}
		};
		default: return {
			...n,
			class: "text",
			properties: {}
		};
	}
}
//#endregion
//#region lib/with/withEditableVoids.ts
function ft(e, t) {
	let { isVoid: n } = e, r = [], i = [];
	return t.forEach((e) => {
		r.push(e.type), e.class === "void" && i.push(e.type);
	}), e.isVoid = (e) => i.includes(e.type) || !r.includes(e.type) ? !0 : n(e), e;
}
//#endregion
//#region lib/with/withInsertBreak.ts
function pt(e, t) {
	let { insertBreak: n } = e;
	return e.insertBreak = () => {
		if (!mt(e, t)) return;
		let { selection: r } = e;
		if (r && S.isCollapsed(r)) {
			let [, t] = h.node(e, r);
			for (let [n, r] of h.levels(e, { at: t })) if (!(r.length <= 1) && z.isBlock(n)) {
				T.splitNodes(e, {
					match: (e) => _.isElement(e),
					mode: "lowest",
					always: !0
				});
				return;
			}
		}
		let { isAtEnd: i, next: a } = gt(e) || {};
		if (i) {
			if (!ht(e, t)) {
				n();
				return;
			}
			T.insertNodes(e, {
				id: crypto.randomUUID(),
				class: "text",
				type: "core/text",
				children: [{ text: "" }]
			}, a ? { at: a } : void 0), a && T.select(e, h.start(e, a));
			return;
		}
		n();
	}, e;
}
function mt(e, t) {
	let { selection: n } = e;
	if (!n) return !0;
	let r = S.isCollapsed(n) ? [n.anchor] : [n.anchor, n.focus];
	for (let n of r) for (let [r, i] of h.levels(e, { at: n })) {
		if (!_.isElement(r)) continue;
		let n = t.get(r.type);
		if (!n) continue;
		if (n.componentEntry?.constraints?.allowBreak === !1) return !1;
		let a = n.componentEntry?.constraints?.max;
		if (a !== void 0 && i.length > 1) {
			let t = i.slice(0, -1), [n] = h.node(e, t);
			if (_.isElement(n)) {
				let e = 0;
				for (let t of n.children) _.isElement(t) && t.type === r.type && e++;
				if (e >= a) return !1;
			}
		}
	}
	return !0;
}
function ht(e, t) {
	let { selection: n } = e;
	if (!n) return !0;
	let r = S.isCollapsed(n) ? [n.anchor] : [n.anchor, n.focus];
	for (let n of r) for (let [r] of h.levels(e, { at: n })) if (_.isElement(r) && t.get(r.type)?.componentEntry?.constraints?.allowExitBreak === !1) return !1;
	return !0;
}
function gt(e) {
	let { selection: t } = e;
	if (!t || !S.isCollapsed(t)) return;
	let [n, r] = h.node(e, t);
	if (!C.isText(n)) return;
	let i = [r[0]], a = h.node(e, i), o = h.last(e, i);
	return {
		isAtEnd: h.isEnd(e, t.anchor, o?.[1] ?? r),
		next: z.isBlock(a[0]) ? b.next(a[1]) : void 0
	};
}
//#endregion
//#region lib/with/withInsertSoftBreak.ts
function _t(e, t) {
	return e.insertSoftBreak = () => {
		vt(e, t) && T.insertText(e, "\n");
	}, e;
}
function vt(e, t) {
	let { selection: n } = e;
	if (!n) return !1;
	let r = S.isCollapsed(n) ? [n.anchor] : [n.anchor, n.focus], i = !1;
	for (let n of r) for (let [r] of h.levels(e, { at: n })) {
		if (!_.isElement(r)) continue;
		let e = t.get(r.type)?.componentEntry?.constraints;
		if (e?.allowSoftBreak === !1) return !1;
		e?.allowSoftBreak === !0 && (i = !0);
	}
	return i;
}
//#endregion
//#region lib/utils/componentConstraints.ts
function yt(e) {
	let { allowBreak: t, allowSoftBreak: n, normalizeNode: r, allowEdgeWhitespace: i, min: a, max: o } = e?.constraints ?? {};
	return {
		min: a,
		max: o,
		allowBreak: t ?? !0,
		allowSoftBreak: n ?? !1,
		allowEdgeWhitespace: i ?? !0,
		normalizeNode: r instanceof Function ? r : void 0
	};
}
//#endregion
//#region lib/utils/normalizeWhitespace.ts
var bt = "\xA0";
function xt(e) {
	return e && e.replace(/\s+/g, (e) => e.includes(bt) ? bt : " ");
}
//#endregion
//#region lib/utils/normalizeLineEndings.ts
function St(e) {
	return e.replace(/\r\n|\r/g, "\n");
}
//#endregion
//#region lib/utils/pasteToParagraphs.ts
function Ct(e, t, n) {
	let { selection: r } = e;
	if (!r) return !1;
	let i = S.edges(r);
	if (!S.isCollapsed(r) && b.compare(i[0].path, i[1].path) !== 0) return !1;
	let a = B.parent(e, r), o = a[0], { componentEntry: s = void 0 } = t.get(o.type) || {};
	if (!s || o.class !== "text") return !1;
	let c, { allowBreak: l } = yt(s);
	c = l ? St(n).replace(/\n{2,}/g, "\n").trim().split("\n").map((e) => e.trim()) : [xt(n)];
	let u = "core/text", d;
	a[1].length > 1 && (u = o.type, d = o.properties);
	let f = c.map((e) => ({
		id: crypto.randomUUID(),
		type: u,
		class: "text",
		children: [{ text: e }],
		properties: d
	})), p = f.shift();
	return p && T.insertFragment(e, [p]), T.insertNodes(e, f), !0;
}
//#endregion
//#region lib/utils/utils.ts
function wt(e) {
	let { selection: t } = e;
	return Array.from(h.nodes(e, {
		at: h.unhangRange(e, t),
		match: (e) => !h.isEditor(e) && _.isElement(e) && [
			"block",
			"void",
			"text",
			"textblock"
		].includes(e.class || "")
	}));
}
function Tt(e) {
	return wt(e).map((e) => e[0]);
}
function Et(e, t) {
	try {
		if (D.hasDOMNode(e, t)) {
			let n = D.toSlateNode(e, t);
			return [n, D.findPath(e, n)];
		}
	} catch (e) {
		console.warn(e);
	}
}
function Dt(e, t) {
	let n, r;
	if (document.caretPositionFromPoint) {
		let e = document.caretPositionFromPoint(t.clientX, t.clientY);
		n = e?.offsetNode, r = e?.offset ?? 0;
	} else if (document.caretRangeFromPoint) {
		let e = document.caretRangeFromPoint(t.clientX, t.clientY);
		n = e?.startContainer, r = e?.startOffset ?? 0;
	} else return;
	if (!n || n?.nodeType !== 3) return;
	let i = D.findEventRange(e, t), a = i.anchor.offset <= i.focus.offset, o = n.nodeValue?.length || 0;
	return {
		anchor: {
			path: i.anchor.path,
			offset: i.anchor.offset + (a ? -r : o - r)
		},
		focus: {
			path: i.focus.path,
			offset: i.focus.offset + (a ? o - r : -r)
		}
	};
}
//#endregion
//#region lib/with/withInsertHtml.ts
function Ot(e, t, n) {
	let { insertData: r, insertText: i } = e, a = n.filter((e) => R.isElementPlugin(e) && !!e.consumer?.consume && !!e.consumer?.consumes).map(({ consumer: e }) => e);
	e.insertData = (n) => {
		let { types: o } = n, { selection: s } = e, c = !0;
		if (s && S.isCollapsed(s)) {
			let n = Tt(e), r = n.length && n[n.length - 1];
			_.isElement(r) && (c = t.get(r.type || "")?.componentEntry.constraints?.allowBreak ?? !0);
		}
		if (c && o.includes("application/x-slate-fragment")) return r(n);
		let l = tt(e, a, {
			source: "html",
			type: "text/html",
			data: n
		});
		if (l instanceof Promise) {
			l.then((e) => {
				if (typeof e == "string") return i(e);
			});
			return;
		}
		if (o.includes("text/plain")) {
			let r = n.getData("text/plain"), i = /\n{2,}/.test(St(r));
			if (r && (!c || o.includes("text/html") || i) && Ct(e, t, r)) return;
		}
		r(n);
	};
}
//#endregion
//#region lib/with/withUniqueIds.ts
function kt(e) {
	let { apply: t } = e;
	return e.apply = (n) => {
		if (n.type === "insert_node") {
			let r = At(e, n.node);
			if (r) return t({
				...n,
				node: r
			});
		}
		if (n.type === "split_node") {
			let r = n.properties;
			if ("id" in r && typeof r.id == "string" && Mt(e, r)) return t({
				...n,
				properties: {
					...n.properties,
					id: crypto.randomUUID()
				}
			});
		}
		t(n);
	}, e;
}
function At(e, t) {
	if (!_.isElement(t)) return null;
	let n = jt(e), r = !1, i = structuredClone(t), a = (e) => {
		if (_.isElement(e)) {
			(!e.id || n.has(e.id)) && (e.id = crypto.randomUUID(), r = !0), n.add(e.id);
			for (let t of e.children) a(t);
		}
	};
	return a(i), r ? i : null;
}
function jt(e) {
	let t = /* @__PURE__ */ new Set();
	for (let [n] of h.nodes(e, {
		at: [],
		mode: "all"
	})) !h.isEditor(n) && _.isElement(n) && typeof n.id == "string" && t.add(n.id);
	return t;
}
function Mt(e, t) {
	return t.id ? Array.from(h.nodes(e, {
		at: [],
		mode: "all",
		match: (e) => !h.isEditor(e) && _.isElement(e) && e.id === t.id
	})).length > 0 : !1;
}
//#endregion
//#region lib/with/withDeletionManagement.ts
function Nt(e) {
	let { deleteBackward: t, deleteForward: n } = e;
	return e.deleteBackward = (n) => {
		let { selection: r } = e;
		if (r && Pt(e)) {
			let [i] = h.nodes(e, {
				match: (t) => _.isElement(t) && h.isBlock(e, t),
				at: r
			});
			if (!i) return t(n);
			let [a, o] = i, s = y.string(a), c = h.first(e, o);
			if (c && z.isBlock(a) && b.equals(r.focus.path, c[1]) && r.focus.offset === 0) return;
			if (!s.length && o[0] === 0) {
				e.children.length > 1 && T.removeNodes(e, { at: o });
				return;
			}
			let l = b.next(o);
			if (!s.length && l[0] >= e.children.length) {
				T.removeNodes(e, { at: o });
				return;
			}
			if (o[0] > 0) {
				let t = b.previous(o), n = h.node(e, t);
				if (n) {
					let [r] = n;
					if (_.isElement(r) && r.class === "block") {
						s.length ? T.removeNodes(e, { at: t }) : (T.removeNodes(e, { at: o }), T.select(e, h.end(e, t)));
						return;
					}
				}
			}
		}
		t(n);
	}, e.deleteForward = (t) => {
		let { selection: r } = e;
		if (r && Ft(e)) {
			let [i] = h.nodes(e, {
				match: (t) => _.isElement(t) && h.isBlock(e, t),
				at: r
			});
			if (!i) return n(t);
			let [a, o] = i, s = y.string(a);
			if (!s.length && o[0] === 0 && e.children.length > 1) {
				T.removeNodes(e, { at: o });
				return;
			}
			if (o[0] < e.children.length - 1) {
				let [t, n] = h.node(e, [o[0] + 1]);
				if (_.isElement(t) && t.class === "block") {
					s.length ? T.removeNodes(e, { at: n }) : (T.removeNodes(e, { at: o }), T.select(e, h.end(e, [o[0] - 1])));
					return;
				}
			}
		}
		n(t);
	}, e;
}
function Pt(e) {
	let { selection: t } = e;
	if (!t || !S.isCollapsed(t)) return !1;
	let [n, r] = h.node(e, t);
	if (!C.isText(n)) return !1;
	let i = [r[0]], a = h.first(e, i);
	return h.isStart(e, t.anchor, a?.[1] ?? r);
}
function Ft(e) {
	let { selection: t } = e;
	if (!t || !S.isCollapsed(t)) return !1;
	let [n, r] = h.node(e, t);
	if (!C.isText(n)) return !1;
	let i = [r[0]], a = h.last(e, i);
	return h.isEnd(e, t.anchor, a?.[1] ?? r);
}
//#endregion
//#region lib/with/withInsertFragment.ts
function It(e, t) {
	let { insertFragment: n } = e;
	return e.insertFragment = (r, i) => {
		let { selection: a } = e;
		if (!a) {
			n(r, i);
			return;
		}
		if (r.length === 1 && Lt(r[0])) {
			let e = zt(r[0]);
			e.length && n(e, i);
			return;
		}
		if (!r.every(z.isText) && Ht(e, a, t)) {
			let t = r.map((e) => y.string(e)).join("\n");
			e.insertText(t);
			return;
		}
		if (!r.every(z.isText)) {
			let t = a.anchor, o = a.focus;
			if (t.path[0] === o.path[0]) {
				let n = t.path[0], i = e.children[n];
				if (_.isElement(i) && i.class === "text") {
					S.isCollapsed(a) || T.delete(e);
					let t = e.selection.anchor, i = x.equals(t, h.start(e, [n])), o = x.equals(t, h.end(e, [n])), s = !i && !o, c = i ? n : n + 1;
					h.withoutNormalizing(e, () => {
						s && T.splitNodes(e, {
							at: t,
							match: (e, t) => t.length === 1
						});
						for (let t = 0; t < r.length; t++) T.insertNodes(e, r[t], { at: [c + t] });
					}), T.select(e, h.end(e, [c + r.length - 1]));
					return;
				}
			}
			n(r, i);
			return;
		}
		let [o, s] = S.edges(a), c = b.equals(o.path, s.path) ? s : Bt(e, s), [l] = Vt(e, o.path, c.path) ?? [];
		if (!z.isText(l)) {
			n(r, i);
			return;
		}
		if (y.string(l)?.length && S.isCollapsed(a)) {
			n(r, i);
			return;
		}
		let u = r.map((e) => {
			if (e.type === l.type && e.properties?.role === l.properties?.role) return e;
			let t = { ...e };
			return t.properties ? t.properties.role = l.properties?.role : t.properties = { role: l.properties?.role }, t;
		});
		n(u, i);
	}, e;
}
function Lt(e) {
	return !_.isElement(e) || e.class === "text" ? !1 : Rt(e);
}
function Rt(e) {
	return C.isText(e) ? !0 : !_.isElement(e) || e.class === "void" ? !1 : e.class === "text" ? e.children.every((e) => C.isText(e)) : e.children.length === 1 && Rt(e.children[0]);
}
function zt(e) {
	return C.isText(e) ? [e] : _.isElement(e) ? e.children.flatMap(zt) : [];
}
function Bt(e, t) {
	if (t.offset !== 0 || t.path[0] === 0) return t;
	try {
		let n = h.start(e, [t.path[0]]);
		if (x.equals(t, n)) return h.end(e, [t.path[0] - 1]);
	} catch (e) {
		console.trace(e);
	}
	return t;
}
function Vt(e, t, n) {
	let r = b.equals(t, n) ? t : b.common(t, n);
	for (; r.length > 0;) try {
		let [t] = h.node(e, r);
		if (_.isElement(t) && t.class === "text") return [t, r];
		r = r.slice(0, -1);
	} catch (e) {
		console.trace(e);
	}
	return null;
}
function Ht(e, t, n) {
	let r = t.anchor.path;
	if (r.length <= 1) return !1;
	for (let t = r.length - 1; t >= 1; t--) {
		let i = r.slice(0, t);
		try {
			let [t] = h.node(e, i);
			if (!_.isElement(t)) continue;
			if (t.class !== "text") return !1;
			let r = n.get(t.type);
			return r ? r.parent !== null : !1;
		} catch {
			return !1;
		}
	}
	return !1;
}
//#endregion
//#region lib/with/withTrimWhitespace.ts
function Ut(e) {
	let { insertText: t } = e;
	return e.insertText = (n) => {
		if (e.allowEdgeWhitespace === !1 && /^[\t\n\r\f\v ]+$/.test(n)) {
			let { selection: t } = e;
			if (t && S.isCollapsed(t)) {
				for (let [n, r] of h.levels(e, { at: t.anchor })) if (!(!_.isElement(n) || r.length !== 1) && h.isStart(e, t.anchor, r)) return;
			}
		}
		t(n);
	}, e;
}
//#endregion
//#region lib/utils/blockBoundarySelection.ts
function U(e) {
	let { selection: t } = e;
	if (!t || S.isCollapsed(t)) return !1;
	let n = Wt(e, t.anchor.path), r = Wt(e, t.focus.path);
	return !(n === void 0 && r === void 0 || n && r && b.equals(n, r));
}
function Wt(e, t) {
	return h.above(e, {
		at: t,
		match: (e) => _.isElement(e) && z.isBlock(e)
	})?.[1];
}
function Gt(e, t) {
	h.withoutNormalizing(e, () => {
		let n = Array.from(h.nodes(e, {
			at: t,
			match: (e) => C.isText(e)
		})).reverse();
		for (let [, r] of n) {
			let n = S.intersection(t, h.range(e, r));
			n && !S.isCollapsed(n) && T.delete(e, { at: n });
		}
	});
}
//#endregion
//#region lib/with/withBlockBoundaryGuard.ts
function Kt(e) {
	let { insertText: t, insertFragment: n, insertData: r, insertBreak: i, insertSoftBreak: a, deleteFragment: o } = e;
	return e.insertText = (n, r) => {
		if (U(e)) {
			qt(e, () => t(n, r));
			return;
		}
		t(n, r);
	}, e.insertData = (n) => {
		if (U(e)) {
			if (n.types.includes("application/x-slate-fragment")) return;
			let r = n.getData("text/plain");
			r && qt(e, () => t(r));
			return;
		}
		r(n);
	}, e.insertFragment = (t, r) => {
		U(e) || n(t, r);
	}, e.insertBreak = () => {
		U(e) || i();
	}, e.insertSoftBreak = () => {
		U(e) || a();
	}, e.deleteFragment = (t) => {
		if (U(e)) {
			let { selection: t } = e;
			if (t) {
				let n = h.pointRef(e, t.focus);
				Gt(e, t);
				let r = n.unref();
				r && T.select(e, r);
			}
			return;
		}
		o(t);
	}, e;
}
function qt(e, t) {
	let { selection: n } = e;
	if (!n) return;
	let r = h.pointRef(e, n.focus);
	Gt(e, n);
	let i = r.unref();
	i && (T.select(e, i), t());
}
//#endregion
//#region lib/with/withSelectionGuard.ts
function Jt(e) {
	let { apply: t } = e;
	return e.apply = (n) => {
		t(n);
		let r = e.selection;
		r && (!Yt(e, r.anchor.path) || !Yt(e, r.focus.path)) && (console.warn("[textbit] Cleared stale selection that pointed outside the document.", {
			selection: r,
			op: n
		}), T.deselect(e));
	}, e;
}
function Yt(e, t) {
	let n = e;
	for (let e = 0; e < t.length; e++) {
		let r = t[e];
		if (r < 0 || r >= n.children.length) return !1;
		let i = n.children[r];
		if (e === t.length - 1) return !0;
		if (!_.isElement(i)) return !1;
		n = i;
	}
	return !0;
}
//#endregion
//#region lib/components/SlateContainer.tsx
function Xt(e) {
	let { children: t, value: n, readOnly: i } = e, { debounce: o, spellcheckDebounce: c, dispatch: u, lang: d } = G(), { plugins: p, components: m } = W(), h = l(null), g = l(Symbol("textbit-editor"));
	if (!h.current) {
		let t = N(E());
		Qt(e) ? (t = ce(le(t, e.value, { localOrigin: g.current })), I.isYjsEditor(t) && $t(e) && (t = se(t, e.awareness, {
			autoSend: e.cursor?.autoSend ?? !0,
			data: e.cursor?.data ?? void 0,
			cursorStateField: e.cursor?.stateField,
			cursorDataField: e.cursor?.dataField
		}))) : t = ue(t), Ze(t, d), e.onSpellcheck && !i && Qe(t, e.onSpellcheck, c), et(t), it(t, p), It(t, m), at(t, p, m), ft(t, m), Ut(t), pt(t, m), _t(t, m), Ot(t, m, p), kt(t), Nt(t), Kt(t), Jt(t), h.current = t;
	}
	let _ = h.current;
	a(() => {
		if (I.isYjsEditor(_)) return I.connect(_), () => {
			I.disconnect(_);
		};
	}, [_]);
	let v = s(() => n instanceof P.XmlText ? [] : typeof n == "string" ? Zt(n) : n, [n]), b = r((t) => {
		e.onChange && (tn(e) || Qt(e) ? e.onChange(t) : en(e) && e.onChange(t.map((e) => y.string(e)).join("\n"))), u({ stats: Je(_) });
	}, [
		e.onChange,
		e.value,
		u
	]), x = s(() => i ? () => {} : Xe(b, o || 1250), [
		b,
		i,
		o
	]);
	return a(() => (_.spellcheck?.force(), u({ stats: Je(_) }), () => {
		_.spellcheck?.cancel();
	}), [_, u]), /* @__PURE__ */ f(O, {
		editor: _,
		initialValue: v,
		onChange: x,
		children: t
	});
}
function Zt(e) {
	return e.split("\n").map((e) => ({
		id: crypto.randomUUID(),
		type: "core/text",
		class: "text",
		children: [{ text: e }]
	}));
}
function Qt(e) {
	return e.value instanceof P.XmlText;
}
function $t(e) {
	return e.value instanceof P.XmlText && "awareness" in e && e.awareness != null;
}
function en(e) {
	return typeof e.value == "string";
}
function tn(e) {
	return !Qt(e) && !en(e);
}
//#endregion
//#region lib/components/GutterProvider/GutterContext.tsx
var nn = n({
	triggerRef: void 0,
	updateTriggerRef: () => {}
});
//#endregion
//#region lib/components/GutterProvider/GutterProvider.tsx
function rn({ children: e }) {
	let t = l(void 0), n = r((e) => {
		t.current = e;
	}, []);
	return /* @__PURE__ */ f(nn.Provider, {
		value: {
			triggerRef: t,
			updateTriggerRef: n
		},
		children: e
	});
}
//#endregion
//#region lib/components/TextbitRoot.tsx
function an(e) {
	let { children: t, verbose: n, readOnly: r, debounce: i, spellcheckDebounce: a, placeholders: o, plugins: s, className: c, style: l, placeholder: u } = e, d = {
		boxSizing: "border-box",
		textRendering: "optimizeLegibility",
		WebkitFontSmoothing: "antialiased",
		MozOsxFontSmoothing: "grayscale",
		...l
	};
	return /* @__PURE__ */ f("div", {
		className: c,
		style: d,
		children: /* @__PURE__ */ f(he, {
			verbose: !!n,
			readOnly: r,
			collaborative: !r && on(e),
			debounce: i,
			spellcheckDebounce: a,
			placeholders: o,
			placeholder: u,
			dir: e.dir,
			lang: e.lang,
			children: /* @__PURE__ */ f(we, {
				verbose: !!n,
				plugins: [...He.map((e) => e()), ...Array.isArray(s) && s.length ? s : V.map((e) => e())],
				children: /* @__PURE__ */ f(Xt, {
					...e,
					children: /* @__PURE__ */ f(qe, { children: /* @__PURE__ */ f(Ge, { children: /* @__PURE__ */ f(rn, { children: t }) }) })
				})
			})
		})
	});
}
function on(e) {
	return e.value instanceof P.XmlText && "awareness" in e && e.awareness != null;
}
//#endregion
//#region lib/utils/getDecorationRanges.ts
var sn = "\xA0";
function cn(e) {
	return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function ln(e, t, n, r, i, a, o, s) {
	let [c, l] = n, u = [];
	if (t?.size && C.isText(c)) {
		let [n] = h.node(e, [l[0]]);
		if (_.isElement(n) && n.id) {
			let e = t.get(n.id);
			if (e?.errors.length) {
				let t = c.text;
				e.errors.forEach((e) => {
					let n = s?.(e) === !0, r = cn(e.text), i = RegExp(`(?<!\\p{L})${r}(?!\\p{L})`, "giu");
					[...t.matchAll(i)].forEach((t) => {
						t.index !== void 0 && u.push({
							anchor: {
								path: l,
								offset: t.index
							},
							focus: {
								path: l,
								offset: t.index + e.text.length
							},
							spellingError: e,
							spellingAccepted: n
						});
					});
				});
			}
		}
	}
	if (C.isText(c)) for (let e = 0; e < c.text.length; e++) {
		let t = c.text[e];
		t === "\n" ? u.push({
			anchor: {
				path: l,
				offset: e
			},
			focus: {
				path: l,
				offset: e + 1
			},
			newline: !0
		}) : t === sn && u.push({
			anchor: {
				path: l,
				offset: e
			},
			focus: {
				path: l,
				offset: e + 1
			},
			nonBreakingSpace: !0
		});
	}
	if (l.length === 2 && C.isText(c) && !c.text && i !== "none") {
		let t = y.parent(e, l);
		if (_.isElement(t) && y.string(t) === "") {
			let n = t.id === e.children[0].id;
			if (i === "multiple" || i === "single" && n && o !== !1) {
				let e = r.get(t.type)?.componentEntry?.placeholder, n = i === "single" ? a : typeof e == "function" ? e(t) : e ?? "";
				u.push({
					anchor: {
						path: l,
						offset: 0
					},
					focus: {
						path: l,
						offset: 0
					},
					placeholder: n
				});
			}
		}
	}
	return u;
}
//#endregion
//#region lib/components/Element/ChildElement.tsx
function un({ attributes: e, children: t, element: n, entry: r, rootNode: i, options: a }) {
	let o = M(), s = n.lang || o.lang, c = typeof n.properties?.role == "string" && n.properties.role.length > 0 ? n.properties.role : null;
	if (!r.asOwnElement) {
		let { component: l } = r;
		return /* @__PURE__ */ f("div", {
			lang: s,
			"data-id": n.id,
			"data-type": n.type,
			...c ? { "data-role": c } : {},
			...e,
			children: /* @__PURE__ */ f(l, {
				element: n,
				rootNode: i,
				options: a,
				editor: o,
				children: t
			})
		});
	}
	let { component: l } = r, u = {
		...e,
		lang: s,
		"data-id": n.id,
		"data-type": n.type,
		...c ? { "data-role": c } : {}
	};
	return /* @__PURE__ */ f(l, {
		element: n,
		attributes: u,
		rootNode: i,
		options: a,
		editor: o,
		children: t
	});
}
//#endregion
//#region lib/contexts/DragStateContext.tsx
var dn = n({
	dragOver: !1,
	onDragEnter: () => {},
	onDragLeave: () => {},
	onDrop: () => {},
	setOffset: () => {}
});
//#endregion
//#region lib/utils/pipes.ts
function fn(e, t, n) {
	let r = [], i = n.target.files;
	if (!i) return;
	for (let e of i) {
		let t = {
			kind: "file",
			type: e.type,
			name: e.name,
			source: "fileinput",
			input: e,
			consumer: [],
			output: void 0
		};
		r.push(t);
	}
	hn(t, r);
	let a = mn(r), o = 0, s = wt(e);
	if (s) {
		let [, e] = s[s.length - 1];
		o = e[0] + 1;
	} else o = Array.from(h.nodes(e, {
		at: [0],
		match: (e) => !h.isEditor(e) && _.isElement(e)
	})).length;
	yn(e, a, t, n, o);
}
function pn(e, t, n, r) {
	let i = n.dataTransfer, a = vn(i);
	hn(t, a), yn(e, mn(a), t, n, r);
}
function mn(e) {
	let t = [];
	return e.forEach((e) => {
		let n = t.find((t) => t.consumer.find((t) => !!e.consumer.find((e) => e.name === t.name)));
		n ? (e.consumer.forEach((e) => {
			n.consumer.find((t) => t.name === e.name) || n.consumer.push(e);
		}), n.pipe.push(e)) : t.push({
			consumer: e.consumer,
			pipe: [e]
		});
	}), t;
}
function hn(e, t) {
	for (let n of t) {
		let { source: t, type: r, input: i } = n;
		e.forEach((e) => {
			if (!R.isElementPlugin(e) || typeof e.consumer?.consumes != "function") return !1;
			let [a, o = void 0, s = !1] = e.consumer.consumes({ input: {
				source: t,
				type: r,
				data: i
			} });
			a === !0 && n.consumer.push({
				name: e.name,
				produces: o || void 0,
				aggregate: s
			});
		});
	}
}
var gn = ["chromium/"];
function _n(e) {
	return gn.some((t) => e.startsWith(t));
}
function vn(e) {
	let t = [], n = !0;
	e.types.includes("text/plain") && (e.types.includes("text/uri-list") || e.types.includes("text/html")) && (n = !1);
	for (let r = 0; r < e.items.length; r++) {
		let i = e.items[r];
		i.kind === "string" && _n(i.type) || (i.kind === "file" ? t.push(wn("drop", i)) : i.type === "text/uri-list" ? t.push(...Tn("drop", e, i, !n)) : i.type === "text/html" ? t.push(Cn("drop", e, i, !n)) : i.type === "text/plain" ? n && t.push(Sn("drop", e, i)) : t.push(Sn("drop", e, i)));
	}
	return t;
}
async function yn(e, t, n, r, i) {
	r.preventDefault(), r.stopPropagation();
	let a = 0;
	for (let r of t) {
		if (r.consumer.length === 0) {
			if (r.pipe.find((e) => e.type === "textbit/droppable-id")) En(e, r.pipe[0].input, i);
			else {
				let e = r.pipe.map((e) => e.type).join(", ");
				console.warn(`Ignored dropped data/files of type ${e}`);
			}
			continue;
		}
		a += await bn(r, e, n, i, a);
	}
}
async function bn(e, t, n, r, i) {
	let a = e.consumer[0], o = n.find((e) => R.isElementPlugin(e) && e.name === a.name), s = o?.consumer?.consume || void 0, c = a?.produces;
	if (!o || !s) return console.warn(`Could not find plugin <${a.name}> or it's consume() function to handle pipe item from $(pipeItem.source})`), 0;
	let l = 0;
	if (a.aggregate) xn(s, e.pipe.map((e) => ({
		source: e.source,
		type: e.type,
		data: e.input
	})), c, t, r + i), l++;
	else for (let n of e.pipe) xn(s, {
		source: n.source,
		type: n.type,
		data: n.input
	}, c, t, r + i + l), l++;
	return l;
}
async function xn(e, t, n, r, i) {
	let a = h.pathRef(r, [i]), o = r.pendingDrops?.start({
		pathRef: a,
		kind: n
	}), s = () => {
		o && r.pendingDrops?.end(o), a.unref();
	}, c;
	try {
		c = await e({
			input: t,
			editor: r
		});
	} catch (e) {
		console.warn(e.message), s();
		return;
	}
	if (c === void 0) {
		s();
		return;
	}
	if (typeof c != "object" || !c || c.type !== n || c.data === void 0) {
		console.warn(`consume(): unexpected result for "${n}"; discarding.`, c), s();
		return;
	}
	let l = a.current;
	if (!l) {
		console.warn(`Drop position for "${n}" was removed before consume() resolved; dropping the consumed result.`), s();
		return;
	}
	let u = c.data;
	T.insertNodes(r, u, {
		at: l,
		select: !1
	}), s();
}
function Sn(e, t, n) {
	return {
		kind: n.kind,
		type: n.type,
		source: e,
		input: t.getData(n.type),
		consumer: [],
		output: void 0
	};
}
function Cn(e, t, n, r) {
	return {
		kind: n.kind,
		type: n.type,
		source: e,
		input: t.getData(n.type),
		alternate: r ? t.getData("text/plain") : void 0,
		consumer: [],
		output: void 0
	};
}
function wn(e, t) {
	return {
		kind: t.kind,
		type: t.type,
		source: e,
		input: t.getAsFile(),
		consumer: [],
		output: void 0
	};
}
function Tn(e, t, n, r) {
	let i = t.getData(n.type), a = [], o = r ? t.getData("text/plain") : void 0;
	for (let t of i.split("\r\n")) a.push({
		kind: n.kind,
		type: n.type,
		source: e,
		input: t,
		alternate: o,
		consumer: [],
		output: void 0
	});
	return a;
}
function En(e, t, n) {
	let r = 0, i;
	for (let n of e.children) {
		if (_.isElement(n) && n.id === t) {
			i = n;
			break;
		}
		r++;
	}
	i && T.moveNodes(e, {
		at: [r],
		to: [n]
	});
}
//#endregion
//#region lib/hooks/usePluginRegistry.tsx
function W() {
	let e = i(Se);
	if (!e) throw Error("useTextbit must be used within a PluginRegistryContextProvider");
	return e;
}
//#endregion
//#region lib/hooks/useTextbit.tsx
var G = () => {
	let e = i(pe);
	if (!e) throw Error("useTextbit must be used within a TextbitProvider");
	return e;
};
//#endregion
//#region lib/utils/hasDraggableTarget.ts
function Dn(e) {
	let t = e.target;
	for (; t && t !== e.currentTarget;) {
		if (t.getAttribute("draggable") === "true") return !0;
		t = t.parentElement;
	}
	return !1;
}
//#endregion
//#region lib/utils/hasDraggableElement.ts
function On(e, t) {
	let n = D.findEventRange(e, t);
	if (!S.isRange(n)) return !1;
	let r = n.anchor.path;
	do {
		let t = y.get(e, r);
		if (_.isElement(t) && t.class === "text") return !1;
		r = r.slice(0, -1);
	} while (r.length > 0);
	return !0;
}
//#endregion
//#region lib/components/Element/Droppable.tsx
function kn({ children: e, element: t }) {
	let { readOnly: n } = G(), a = M(), o = i(dn), { plugins: s } = W(), c = l(null), u = s.find((e) => e.name === t?.type), d = R.isElementPlugin(u) && !!u?.componentEntry?.droppable, p = r((e) => {
		if (!(n || !t?.id)) {
			if (!Dn(e) && !On(a, e)) {
				e.stopPropagation(), e.preventDefault();
				return;
			}
			e.stopPropagation(), c?.current && jn(c.current, e, t.id);
		}
	}, [
		n,
		t?.id,
		a
	]), m = r((e) => !n && (e.preventDefault(), e.stopPropagation(), !0), [n]), h = r((e) => {
		m(e) && o?.onDragEnter();
	}, [o, m]), g = r((e) => {
		m(e) && o?.onDragLeave();
	}, [o, m]), _ = r((e) => {
		m(e) && o.setOffset(Nn(e, c?.current, d));
	}, [
		o,
		m,
		d
	]), v = r((e) => {
		if (n) {
			e.preventDefault();
			return;
		}
		if (o?.onDrop && o.onDrop(e), !c.current || !t?.id) return;
		let r = Mn(a, e, c.current, t.id, d);
		r && pn(a, s, e, r[0]);
	}, [
		o,
		t?.id,
		a,
		d,
		s,
		c,
		n
	]), y = r(() => {
		n || (o?.onDragLeave(), c?.current && (c.current.style.opacity = "1", An()));
	}, [n, o]);
	return /* @__PURE__ */ f("div", {
		"data-id": t?.id || "",
		ref: c,
		draggable: !n && ["block", "void"].includes(t?.class || "") ? "true" : "false",
		onDragStartCapture: p,
		onDragEnterCapture: h,
		onDragLeaveCapture: g,
		onDragOverCapture: _,
		onDropCapture: v,
		onDragEnd: y,
		children: e
	});
}
function An() {
	let e = document.getElementsByClassName("textbit-dragged-temp");
	if (e.length) for (let t of e) t.parentNode && t.parentNode.removeChild(t);
}
function jn(e, t, n) {
	let r = e.cloneNode(!0), { left: i, top: a } = e.getBoundingClientRect(), o = r.firstChild;
	o.style.transform = "scale(0.6) rotate(2deg)", r.style.width = `${e.offsetWidth}px`, r.style.height = `${e.offsetHeight}px`, r.style.position = "absolute", r.style.top = "-9999px", r.classList.add("textbit-dragged-temp"), document.body.appendChild(r), e.style.opacity = "0.5", t.dataTransfer.clearData(), t.dataTransfer.setData("textbit/droppable-id", n), t.dataTransfer.setDragImage(r, t.clientX - i, t.clientY - a);
}
function Mn(e, t, n, r, i) {
	let a = e.children.findIndex((e) => _.isElement(e) && e.id === r);
	return a < 0 ? null : [a + (Nn(t, n, i)?.position?.[0] === "above" ? 0 : 1), e.children[a]];
}
function Nn(e, t, n) {
	if (!t) return;
	let r = t.getBoundingClientRect(), i = e.clientY;
	if (e.clientX < r.left || e.clientX > r.right) return {
		position: void 0,
		bbox: r
	};
	let a = (i - r.top) / r.height * 100, o;
	return o = a <= 20 ? ["above", !1] : a <= 50 ? ["above", n] : a >= 80 ? ["below", n] : ["below", !1], {
		position: o,
		bbox: r
	};
}
//#endregion
//#region lib/contexts/AdjacentBlockContext.tsx
var Pn = n(null);
//#endregion
//#region lib/hooks/useAdjacentBlock.tsx
function Fn() {
	return i(Pn);
}
//#endregion
//#region lib/contexts/BlockSelectionContext.tsx
var In = n(null);
//#endregion
//#region lib/hooks/useBlockSelection.tsx
function K() {
	return i(In);
}
//#endregion
//#region lib/components/Element/ParentElement.tsx
function Ln(e) {
	let t = k(), n = M(), r = Fn(), i = K(), { element: a, attributes: o, entry: s } = e;
	if (s.asOwnElement) return null;
	let c = (() => {
		if (!i) return !1;
		let e = n.children.findIndex((e) => e === a);
		if (e === -1) return !1;
		let t = Math.min(i.anchorIndex, i.focusIndex), r = Math.max(i.anchorIndex, i.focusIndex);
		return e >= t && e <= r;
	})(), l = r && r.blockId === a.id ? r.direction : null, u = typeof a.properties?.role == "string" && a.properties.role.length > 0 ? a.properties.role : null, d = {
		position: "absolute",
		top: 0,
		bottom: 0,
		insetInlineEnd: -5,
		width: 1,
		backgroundColor: "currentColor",
		pointerEvents: "none",
		animation: "block-caret-blink 1s step-end infinite"
	}, m = l === "before" ? "before" : l === "after" ? "after" : t ? "active" : "inactive";
	return /* @__PURE__ */ f(kn, {
		element: a,
		children: /* @__PURE__ */ p("div", {
			lang: e.element.lang || n.lang,
			"data-id": a.id,
			"data-type": a.type,
			...u ? { "data-role": u } : {},
			"data-state": m,
			...c ? { "data-block-selected": "" } : {},
			className: `${a.class} ${a.type} ${s.class} relative group`,
			style: {
				position: "relative",
				...c ? { userSelect: "none" } : {}
			},
			...o,
			children: [
				/* @__PURE__ */ f(s.component, {
					element: a,
					options: e.options,
					editor: n,
					children: e.children
				}),
				a.class !== "text" && a.class !== "inline" && /* @__PURE__ */ f("div", {
					contentEditable: !1,
					className: "tb-focus-ring",
					style: {
						position: "absolute",
						inset: 0,
						pointerEvents: "none"
					}
				}),
				c && /* @__PURE__ */ f("div", {
					contentEditable: !1,
					className: "tb-block-selected",
					style: {
						position: "absolute",
						inset: -2,
						pointerEvents: "none",
						outline: "2px solid Highlight",
						outlineOffset: "2px",
						borderRadius: "var(--tb-focus-ring-radius, 5px)"
					}
				}),
				l === "before" && /* @__PURE__ */ f("div", {
					"aria-hidden": !0,
					style: {
						...d,
						insetInlineEnd: "unset",
						insetInlineStart: -5
					}
				}),
				l === "after" && /* @__PURE__ */ f("div", {
					"aria-hidden": !0,
					style: d
				})
			]
		})
	});
}
//#endregion
//#region lib/components/Element/InlineElement.tsx
function Rn({ attributes: e, children: t, element: n, entry: r, options: i }) {
	let a = M();
	return r.asOwnElement ? null : /* @__PURE__ */ f("span", {
		className: `inline ${r.type}`,
		"data-id": n.id,
		"data-type": n.type,
		...e,
		children: /* @__PURE__ */ f(r.component, {
			element: n,
			options: i,
			editor: a,
			children: t
		})
	});
}
//#endregion
//#region lib/components/Element/UnknownElement.tsx
function zn({ element: e, attributes: t, children: n }) {
	return /* @__PURE__ */ f(kn, { children: /* @__PURE__ */ p("div", {
		contentEditable: !1,
		className: "textbit-parent textbit-unknown",
		"data-id": e.id,
		"data-type": e.type,
		...t,
		children: [/* @__PURE__ */ p("pre", {
			style: { fontSize: "80%" },
			children: [
				" ",
				"UNKNOWN OBJECT(",
				e.type,
				")"
			]
		}), /* @__PURE__ */ f("div", {
			style: { opacity: "0.4" },
			children: n
		})]
	}) });
}
//#endregion
//#region lib/components/Element/Element.tsx
function Bn(e) {
	let t = M(), { element: n } = e, { components: r } = W(), i = r.get(n.type);
	if (!i) return /* @__PURE__ */ f(zn, { ...e });
	let a = D.findPath(t, n);
	if (a.length === 1) return /* @__PURE__ */ f(Ln, {
		...e,
		entry: i.componentEntry,
		options: i.pluginOptions
	});
	if (i.class === "inline") return /* @__PURE__ */ f(Rn, {
		...e,
		entry: i.componentEntry,
		options: i.pluginOptions
	});
	let o = y.get(t, [a[0]]);
	return /* @__PURE__ */ f(un, {
		...e,
		entry: i.componentEntry,
		rootNode: o,
		options: i.pluginOptions
	});
}
//#endregion
//#region lib/components/Element/LeafElement.tsx
function Vn(e) {
	let { leaf: t } = e, { plugins: n } = W();
	if (!t) return /* @__PURE__ */ f(d, {});
	let r = Object.keys(t).reduce((e, n) => t[n] === !0 ? [...e, n] : e, []), i = "leaf", a = {};
	for (let e of n) if (r.includes(e.name) && R.isLeafPlugin(e)) {
		let t = e.getStyle();
		typeof t == "string" ? i += t ? ` ${t}` : "" : a = {
			...a,
			...t
		};
	}
	return t.text === "" && (a.paddingLeft = "0.1px"), t.spellingError ? /* @__PURE__ */ f(Kn, {
		...e,
		className: i,
		style: a
	}) : t.placeholder ? /* @__PURE__ */ f(Gn, {
		...e,
		className: i,
		style: a
	}) : t.newline ? /* @__PURE__ */ f(Hn, {
		...e,
		className: i,
		style: a
	}) : t.nonBreakingSpace ? /* @__PURE__ */ f(Un, {
		...e,
		className: i,
		style: a
	}) : /* @__PURE__ */ f(Wn, {
		...e,
		className: i,
		style: a
	});
}
function Hn(e) {
	let { attributes: t, style: n, className: r } = e;
	return /* @__PURE__ */ f("span", {
		style: n,
		className: `${r} tb-newline`,
		"data-newline": !0,
		...t,
		children: e.children
	});
}
function Un(e) {
	let { attributes: t, style: n, className: r } = e;
	return /* @__PURE__ */ f("span", {
		style: {
			...n,
			backgroundColor: "color-mix(in srgb, currentColor 24%, transparent)",
			boxShadow: "inset 0 0 0 1px color-mix(in srgb, currentColor 55%, transparent)",
			borderRadius: "2px"
		},
		className: `${r} textbit-nbsp`,
		"data-nbsp": !0,
		...t,
		children: e.children
	});
}
function Wn(e) {
	let { attributes: t, style: n, className: r } = e;
	return /* @__PURE__ */ f("span", {
		style: n,
		className: r,
		...t,
		children: e.children
	});
}
function Gn(e) {
	let { leaf: t, attributes: n, style: r, className: i } = e, a = l(null), [s, c] = u(void 0);
	return o(() => {
		a.current && c(a.current.offsetWidth);
	}, [t.placeholder]), /* @__PURE__ */ p("div", {
		style: {
			...r,
			width: "100%",
			position: "relative",
			minWidth: s
		},
		className: i,
		...n,
		children: [e.children, t.placeholder && /* @__PURE__ */ f(qn, {
			ref: a,
			value: t.placeholder,
			style: r
		})]
	});
}
function Kn(e) {
	let { leaf: t, attributes: n, style: r, className: i } = e, a = t.spellingError;
	return /* @__PURE__ */ f("span", {
		style: r,
		className: i,
		"data-spelling-error": a?.id || "",
		"data-spelling-level": a?.level || void 0,
		"data-spelling-accepted": t.spellingAccepted ? "" : void 0,
		...n,
		children: e.children
	});
}
function qn({ value: e, style: t, ref: n }) {
	return /* @__PURE__ */ f("div", {
		ref: n,
		"data-slate-placeholder": !0,
		style: {
			...t,
			opacity: .333,
			position: "absolute",
			top: 0,
			pointerEvents: "none",
			whiteSpace: "nowrap"
		},
		contentEditable: !1,
		children: e
	});
}
//#endregion
//#region lib/hooks/useContextMenu.tsx
function Jn(e = !0) {
	let t = M(), n = i(H);
	return s(() => (r) => {
		let i = r.target.nodeType === Node.TEXT_NODE ? r.target.parentElement : r.target;
		if (!i) return;
		let [a, o] = Et(t, i) || [];
		if (!a || !Array.isArray(o)) return;
		let s = t.children[o[0]];
		if (!_.isElement(s)) return;
		let c = Yn(t, s, i, r), l = Dt(t, r);
		l && (T.select(t, l), D.focus(t)), e && r.preventDefault(), c && n?.dispatch({
			menu: {
				position: {
					x: r.clientX,
					y: r.clientY
				},
				target: i,
				originalEvent: r,
				nodeEntry: [a, o]
			},
			spelling: c
		});
	}, [
		n,
		e,
		t
	]);
}
function Yn(e, t, n, r) {
	let i = n.closest("[data-spelling-error]"), a = i?.dataset.spellingError;
	if (!t.id || !a) return;
	let o = (e.spellingLookupTable.get(t.id)?.errors || []).find((e) => e.id === a);
	try {
		return o ? {
			...o,
			range: Dt(e, r),
			accepted: i?.dataset.spellingAccepted !== void 0,
			apply: (t) => {
				B.replaceStringAtPosition(e, o.text, t);
			}
		} : void 0;
	} catch (e) {
		console.warn(e);
	}
}
//#endregion
//#region lib/contexts/DragStateProvider.tsx
function Xn({ children: e }) {
	let t = l(0), [n, r] = u(void 0), [i, a] = u(!1);
	return /* @__PURE__ */ f(dn.Provider, {
		value: {
			dragOver: i,
			offset: n,
			setOffset: r,
			onDragEnter: () => {
				a(!0), t.current++;
			},
			onDragLeave: () => {
				setTimeout(() => {
					--t.current === 0 && a(!1);
				});
			},
			onDrop: () => {
				a(!1);
			}
		},
		children: /* @__PURE__ */ f("div", {
			style: {
				height: "100%",
				position: "relative"
			},
			children: e
		})
	});
}
//#endregion
//#region lib/contexts/PendingDropsContext.tsx
var Zn = n(null);
//#endregion
//#region lib/contexts/PendingDropsProvider.tsx
function Qn({ editor: e, children: t }) {
	let n = A() ?? e, [i, s] = u(() => /* @__PURE__ */ new Map()), c = l(i);
	c.current = i;
	let d = r((e) => {
		let t = crypto.randomUUID();
		return s((n) => {
			let r = new Map(n);
			return r.set(t, {
				pathRef: e.pathRef,
				kind: e.kind
			}), r;
		}), t;
	}, []), p = r((e) => {
		s((t) => {
			let n = t.get(e);
			if (!n) return t;
			n.pathRef.unref();
			let r = new Map(t);
			return r.delete(e), r;
		});
	}, []);
	o(() => (n.pendingDrops = {
		start: d,
		end: p
	}, () => {
		delete n.pendingDrops;
	}), [
		n,
		d,
		p
	]), a(() => () => {
		for (let e of c.current.values()) e.pathRef.unref();
	}, []), a(() => {
		if (!F.isCursorEditor(n)) return;
		let e = n.awareness, t = n.sharedRoot, r = [];
		for (let [e, a] of i) {
			let i = a.pathRef.current;
			if (i) try {
				let o = h.start(n, i), s = oe(t, n, o);
				r.push({
					id: e,
					relPos: Array.from(P.encodeRelativePosition(s)),
					kind: a.kind
				});
			} catch {}
		}
		e.setLocalStateField("pendingDrops", r.length ? r : null);
	}, [n, i]), a(() => {
		if (!F.isCursorEditor(n)) return;
		let e = n.awareness;
		return () => {
			e.setLocalStateField("pendingDrops", null);
		};
	}, [n]);
	let [m, g] = u([]);
	a(() => {
		if (!F.isCursorEditor(n)) return;
		let e = n.awareness, t = e.clientID, r = /* @__PURE__ */ new Map(), i = () => {
			let n = [], i = /* @__PURE__ */ new Map(), a = e.getStates();
			for (let [e, r] of a) {
				if (e === t) continue;
				let a = r.pendingDrops;
				if (Array.isArray(a)) {
					i.set(e, JSON.stringify(a));
					for (let t of a) !t || typeof t.id != "string" || !Array.isArray(t.relPos) || n.push({
						peerId: e,
						raw: t,
						peerData: r.data
					});
				}
			}
			r.clear();
			for (let [e, t] of i) r.set(e, t);
			g(n);
		}, a = ({ added: n, updated: a, removed: o }) => {
			let s = o.some((e) => r.has(e));
			if (!s) {
				let i = e.getStates();
				for (let e of n.concat(a)) {
					if (e === t) continue;
					let n = i.get(e)?.pendingDrops;
					if ((Array.isArray(n) ? JSON.stringify(n) : "") !== (r.get(e) ?? "")) {
						s = !0;
						break;
					}
				}
			}
			s && i();
		};
		return i(), e.on("change", a), () => {
			e.off("change", a);
		};
	}, [n]);
	let _ = l(/* @__PURE__ */ new Map()), v = r((e) => {
		let t = e.join(","), n = _.current.get(t);
		return n || (n = P.decodeRelativePosition(Uint8Array.from(e)), _.current.set(t, n)), n;
	}, []), y = [];
	for (let [e, t] of i) {
		let n = t.pathRef.current;
		n && y.push({
			id: e,
			source: "own",
			path: n,
			kind: t.kind
		});
	}
	if (F.isCursorEditor(n) && m.length) {
		let e = n.sharedRoot;
		for (let { peerId: t, raw: r, peerData: i } of m) try {
			let a = v(r.relPos), o = ae(e, n, a);
			if (!o) continue;
			y.push({
				id: `${t}:${r.id}`,
				source: "peer",
				path: o.path.slice(0, 1),
				kind: r.kind,
				peerId: t,
				peerData: i
			});
		} catch {}
	}
	let b = {
		drops: y,
		start: d,
		end: p
	};
	return /* @__PURE__ */ f(Zn.Provider, {
		value: b,
		children: t
	});
}
//#endregion
//#region lib/components/PresenceOverlay/RemoteCursorOverlay.tsx
function $n({ children: e }) {
	let t = l(null), [n] = de({ containerRef: t });
	return /* @__PURE__ */ p("div", {
		style: {
			height: "100%",
			position: "relative"
		},
		className: "textbit-y-overlay",
		ref: t,
		children: [e, n.map((e) => /* @__PURE__ */ f(er, { ...e }, e.clientId))]
	});
}
function er({ data: e, selectionRects: t, caretPosition: n }) {
	if (!e) return null;
	let r = {
		position: "absolute",
		pointerEvents: "none",
		backgroundColor: e?.color || "gray",
		opacity: .5
	};
	return /* @__PURE__ */ p(d, { children: [t.map((e, t) => /* @__PURE__ */ f("div", {
		className: "textbit-y-selection",
		style: {
			...r,
			...e
		}
	}, t)), n && /* @__PURE__ */ f(tr, {
		caretPosition: n,
		data: e
	})] });
}
function tr({ caretPosition: e, data: t }) {
	let n = l(null), [r, i] = u(!0);
	a(() => {
		if (!n.current) return;
		let e = n.current.closest(".textbit-y-overlay");
		if (!e) return;
		let t = n.current.getBoundingClientRect(), r = e.getBoundingClientRect();
		i(t.top - r.top > t.height);
	}, [e]);
	let o = s(() => ({
		position: "absolute",
		...e,
		background: t?.color || "gray",
		width: "2px"
	}), [e, t?.color]), c = s(() => ({
		backgroundColor: t?.color?.trim() || "gray",
		position: "absolute",
		fontFamily: "sans-serif",
		fontSize: "80%",
		borderRadius: "2px",
		transform: r ? "translateY(-91%)" : `translateY(${e?.height || 44}px)`,
		width: "max-content",
		padding: "0px 6px 1px 6px",
		opacity: .9,
		whiteSpace: "nowrap",
		top: 0,
		borderBottomLeftRadius: 0
	}), [
		t?.color,
		r,
		e?.height
	]);
	return /* @__PURE__ */ f("div", {
		ref: n,
		style: o,
		className: "textbit-y-caret",
		children: /* @__PURE__ */ f("div", {
			style: c,
			children: t?.name || "?"
		})
	});
}
//#endregion
//#region lib/components/PresenceOverlay/PresenceOverlay.tsx
function nr({ children: e, isCollaborative: t }) {
	let { readOnly: n } = G();
	return /* @__PURE__ */ f(d, { children: f(!t || n ? d : $n, { children: e }) });
}
//#endregion
//#region lib/components/SelectionBoundsDetails.tsx
function rr() {
	let e = X(), t = l(null);
	return a(() => {
		t.current && (t.current.style.top = `${e?.y}px`, t.current.style.left = `${e?.x}px`, t.current.style.width = `${e?.width}px`, t.current.style.height = `${e?.height}px`);
	}, [e]), /* @__PURE__ */ f("div", {
		ref: t,
		style: {
			position: "absolute",
			top: 0,
			left: 0,
			outline: "1px solid rgba(191, 191, 99, 0.5",
			outlineOffset: "4px"
		},
		children: e && /* @__PURE__ */ p("div", {
			style: {
				position: "absolute",
				top: "calc(100% + 1px)",
				left: "calc(80% + 4px)",
				pointerEvents: "none",
				background: "rgb(255, 255, 255)",
				borderRadius: "2px",
				padding: "4px 6px",
				color: "rgba(225, 99, 99, 0.8)",
				fontSize: "11px",
				whiteSpace: "nowrap",
				fontFamily: "monospace",
				fontWeight: "bold",
				border: "1px solid rgba(255, 99, 99, 0.8)",
				display: "grid",
				gridTemplateColumns: "1fr 1fr",
				gridTemplateRows: "1fr 1fr",
				gridGap: "6px 10px"
			},
			children: [
				/* @__PURE__ */ p("div", { children: ["x:", Math.round(e.x)] }),
				/* @__PURE__ */ p("div", { children: ["y:", Math.round(e.y)] }),
				/* @__PURE__ */ p("div", { children: ["w:", Math.round(e.width)] }),
				/* @__PURE__ */ p("div", { children: ["h:", Math.round(e.height)] })
			]
		})
	});
}
//#endregion
//#region lib/contexts/AdjacentBlockProvider.tsx
function ir({ value: e, children: t }) {
	return /* @__PURE__ */ f(Pn.Provider, {
		value: e,
		children: t
	});
}
//#endregion
//#region lib/contexts/BlockSelectionProvider.tsx
function ar({ value: e, children: t }) {
	return /* @__PURE__ */ f(In.Provider, {
		value: e,
		children: t
	});
}
//#endregion
//#region lib/utils/hasMark.ts
var or = (e, t) => {
	let n = B.selectedTextEntries(e);
	if (!n.length) return !1;
	for (let [e] of n) if (!C.isText(e) || !Object.keys(e).includes(t) || e[t] !== !0) return !1;
	return !0;
}, sr = (e, t) => {
	or(e, t) ? h.removeMark(e, t) : h.addMark(e, t, !0);
};
//#endregion
//#region lib/components/TextbitEditable/handleOnKeyDown/blockUtils.ts
function cr(e, t) {
	return t.children.findIndex((t) => !_.isElement(t) || !e.isVoid(t));
}
function lr(e, t) {
	return t.children.reduce((t, n, r) => !_.isElement(n) || !e.isVoid(n) ? r : t, -1);
}
function ur(e, t, n) {
	let r = e.children[n];
	if (!_.isElement(r)) return !1;
	let i = cr(e, r);
	return i < 0 ? h.isStart(e, t, [n]) : h.isStart(e, t, [n, i]);
}
function dr(e, t, n) {
	let r = e.children[n];
	if (!_.isElement(r)) return !1;
	let i = lr(e, r);
	return i < 0 ? h.isEnd(e, t, [n]) : h.isEnd(e, t, [n, i]);
}
function q(e, t) {
	return e.children.findIndex((e) => _.isElement(e) && e.id === t.blockId);
}
function fr(e, t) {
	t < e.children.length ? T.select(e, h.start(e, [t])) : e.children.length > 0 && T.select(e, h.end(e, [e.children.length - 1]));
}
function J(e, t, n) {
	let r = t, i = cr(e, n);
	i >= 0 && (r = [...t, i]), T.select(e, h.start(e, r));
}
function Y(e, t, n) {
	let r = t, i = lr(e, n);
	i >= 0 && (r = [...t, i]), T.select(e, h.end(e, r));
}
//#endregion
//#region lib/components/TextbitEditable/handleOnKeyDown/arrowHandlers.ts
function pr(e, t, n, r, i, a) {
	let o = q(e, n);
	if (o === -1) {
		r(null);
		return;
	}
	let s = [o], c = e.children[o], l = _.isElement(c) && e.isVoid(c), { direction: u } = n;
	if (i && u === "before") {
		t.preventDefault(), l ? r({
			blockId: n.blockId,
			direction: "after"
		}) : (J(e, s, c), r(null));
		return;
	}
	if (i && u === "after") {
		t.preventDefault();
		let n = o + 1;
		if (n < e.children.length) {
			let t = e.children[n];
			T.select(e, h.start(e, [n])), _.isElement(t) && t.class !== "text" ? r({
				blockId: t.id,
				direction: "before"
			}) : r(null);
		} else r(null);
		return;
	}
	if (a && u === "after") {
		t.preventDefault(), l ? r({
			blockId: n.blockId,
			direction: "before"
		}) : (Y(e, s, c), r(null));
		return;
	}
	if (a && u === "before") {
		t.preventDefault();
		let n = o - 1;
		if (n >= 0) {
			let t = e.children[n];
			T.select(e, h.end(e, [n])), _.isElement(t) && t.class !== "text" ? r({
				blockId: t.id,
				direction: "after"
			}) : r(null);
		} else r(null);
		return;
	}
	r(null);
}
function mr(e, t, n, r) {
	let i = q(e, n);
	if (i === -1) {
		t.preventDefault();
		return;
	}
	let a = t.key === "ArrowUp", o = a ? i - 1 : i + 1;
	if (o < 0 || o >= e.children.length) {
		t.preventDefault();
		return;
	}
	let s = e.children[o];
	if (_.isElement(s) && s.class !== "text") {
		t.preventDefault(), n.direction === "after" ? Y(e, [o], s) : J(e, [o], s), r({
			blockId: s.id,
			direction: n.direction
		});
		return;
	}
	let c = e.children[i], l = _.isElement(c) && e.isVoid(c);
	if (n.direction === "after" && a || n.direction === "before" && !a || l) {
		t.preventDefault(), T.select(e, a ? h.end(e, [o]) : h.start(e, [o])), r(null);
		return;
	}
	r(null);
}
function hr(e, t, n, r, i, a, o) {
	let s = [a], c = e.children[a];
	if (r) {
		if (_.isElement(c) && c.class !== "text" && dr(e, o, a)) return t.preventDefault(), n({
			blockId: c.id,
			direction: "after"
		}), !0;
		if (h.isEnd(e, o, s)) {
			let r = a + 1;
			if (r < e.children.length) {
				let i = e.children[r];
				if (_.isElement(i) && i.class !== "text") return t.preventDefault(), J(e, [r], i), n({
					blockId: i.id,
					direction: "before"
				}), !0;
			}
		}
	}
	if (i) {
		if (_.isElement(c) && c.class !== "text" && ur(e, o, a)) return t.preventDefault(), n({
			blockId: c.id,
			direction: "before"
		}), !0;
		if (h.isStart(e, o, s)) {
			let r = a - 1;
			if (r >= 0) {
				let i = e.children[r];
				if (_.isElement(i) && i.class !== "text") return t.preventDefault(), T.select(e, h.end(e, [r])), n({
					blockId: i.id,
					direction: "after"
				}), !0;
			}
		}
	}
	return !1;
}
//#endregion
//#region lib/components/TextbitEditable/handleOnKeyDown/nonArrowHandler.ts
function gr(e, t, n, r) {
	if (t.key === "Enter") {
		let i = q(e, n);
		if (i !== -1) {
			t.preventDefault();
			let a = n.direction === "before" ? i : i + 1, o = {
				id: crypto.randomUUID(),
				class: "text",
				type: "core/text",
				children: [{ text: "" }]
			};
			return T.insertNodes(e, o, { at: [a] }), T.select(e, h.start(e, [a])), r(null), !0;
		}
	}
	let { selection: i } = e;
	if (i && S.isCollapsed(i)) {
		if (t.key === "Backspace" && n.direction === "after") {
			let i = q(e, n);
			if (i !== -1) {
				t.preventDefault(), T.removeNodes(e, { at: [i] });
				let n = i - 1;
				return n >= 0 && n < e.children.length ? T.select(e, h.end(e, [n])) : e.children.length > 0 && T.select(e, h.start(e, [0])), r(null), !0;
			}
		}
		if (t.key === "Backspace" && n.direction === "before") {
			let i = q(e, n);
			if (i !== -1) {
				let n = i - 1, a = n >= 0 ? e.children[n] : null;
				if (a && _.isElement(a)) {
					if (t.preventDefault(), a.class !== "text") {
						T.removeNodes(e, { at: [n] });
						let t = e.children[n];
						return _.isElement(t) && t.class !== "text" ? (J(e, [n], t), r({
							blockId: t.id,
							direction: "before"
						})) : (fr(e, n), r(null)), !0;
					}
					return y.string(a) === "" ? (T.removeNodes(e, { at: [n] }), fr(e, n)) : (T.select(e, h.end(e, [n])), T.delete(e, {
						unit: "character",
						reverse: !0
					})), r(null), !0;
				}
			}
		}
		if (t.key === "Delete" && n.direction === "before") {
			let i = q(e, n);
			if (i !== -1) {
				if (t.preventDefault(), T.removeNodes(e, { at: [i] }), i < e.children.length) {
					let t = e.children[i];
					_.isElement(t) && t.class !== "text" ? (J(e, [i], t), r({
						blockId: t.id,
						direction: "before"
					})) : (T.select(e, h.start(e, [i])), r(null));
				} else if (e.children.length > 0) {
					let t = e.children.length - 1, n = e.children[t];
					_.isElement(n) && n.class !== "text" ? (Y(e, [t], n), r({
						blockId: n.id,
						direction: "after"
					})) : (T.select(e, h.end(e, [t])), r(null));
				} else r(null);
				return !0;
			}
		}
	}
	if ([
		"Meta",
		"Control",
		"Alt",
		"Shift",
		"CapsLock"
	].includes(t.key) || (t.metaKey || t.ctrlKey) && t.key === "v") return !0;
	if (t.key.length === 1 && !t.ctrlKey && !t.metaKey && !t.altKey) {
		let t = q(e, n);
		if (t !== -1) {
			let i = n.direction === "before" ? t : t + 1, a = {
				id: crypto.randomUUID(),
				class: "text",
				type: "core/text",
				children: [{ text: "" }]
			};
			return T.insertNodes(e, a, { at: [i] }), T.select(e, h.start(e, [i])), r(null), !0;
		}
	}
	return r(null), !1;
}
//#endregion
//#region lib/components/TextbitEditable/handleOnKeyDown/blockSelectionHandler.ts
function _r(e, t) {
	let n = Math.min(t.anchorIndex, t.focusIndex), r = Math.max(t.anchorIndex, t.focusIndex);
	T.select(e, {
		anchor: h.start(e, [n]),
		focus: h.end(e, [r])
	});
}
function vr(e, t, n) {
	let r = Math.min(t.anchorIndex, t.focusIndex), i = Math.max(t.anchorIndex, t.focusIndex);
	h.withoutNormalizing(e, () => {
		for (let t = i; t >= r; t--) T.removeNodes(e, { at: [t] });
	}), n(null), r < e.children.length ? T.select(e, h.start(e, [r])) : e.children.length > 0 && T.select(e, h.end(e, [e.children.length - 1]));
}
function yr(e, t, n) {
	let r = q(e, n);
	if (r === -1) return null;
	let i = t.key === "ArrowDown" || t.key === "ArrowRight", { direction: a } = n, o;
	if (o = a === "before" && !i ? r - 1 : a === "before" && i || a === "after" && !i ? r : r + 1, o < 0 || o >= e.children.length) return null;
	let s = {
		anchorIndex: o,
		focusIndex: o
	};
	return _r(e, s), s;
}
function br(e, t, n, r, i) {
	let a = t.key, o = a === "ArrowUp" || a === "ArrowDown" || a === "ArrowLeft" || a === "ArrowRight", s = t.metaKey || t.ctrlKey;
	if (t.shiftKey && o) {
		t.preventDefault();
		let i = a === "ArrowDown" || a === "ArrowRight", o = e.children.length - 1, s = i ? Math.min(n.focusIndex + 1, o) : Math.max(n.focusIndex - 1, 0), c = {
			...n,
			focusIndex: s
		};
		r(c), _r(e, c);
		return;
	}
	if (o && !t.shiftKey) {
		t.preventDefault();
		let o = Math.min(n.anchorIndex, n.focusIndex), s = Math.max(n.anchorIndex, n.focusIndex), c = a === "ArrowUp" || a === "ArrowLeft", l = c ? o : s, u = e.children[l];
		r(null), _.isElement(u) && u.class !== "text" ? c ? (J(e, [l], u), i({
			blockId: u.id,
			direction: "before"
		})) : (Y(e, [l], u), i({
			blockId: u.id,
			direction: "after"
		})) : c ? T.select(e, h.start(e, [l])) : T.select(e, h.end(e, [l]));
		return;
	}
	if (a === "Backspace" || a === "Delete") {
		t.preventDefault(), vr(e, n, r);
		return;
	}
	if (!(s && a === "c")) {
		if (s && a === "x") {
			document.execCommand("copy"), t.preventDefault(), vr(e, n, r);
			return;
		}
		s && a === "v" || t.preventDefault();
	}
}
//#endregion
//#region lib/components/TextbitEditable/handleOnKeyDown/handleOnKeyDown.ts
function xr(e, t, n, r, i, a, o) {
	if (a) {
		br(e, n, a, o, i);
		return;
	}
	if (r && n.shiftKey && (n.key === "ArrowUp" || n.key === "ArrowDown" || n.key === "ArrowLeft" || n.key === "ArrowRight")) {
		let t = yr(e, n, r);
		t && (n.preventDefault(), i(null), o(t));
		return;
	}
	let s = n.key, c = s === "ArrowRight", l = s === "ArrowLeft";
	if (c || l) {
		let { selection: t } = e;
		if (!t || !S.isCollapsed(t)) {
			r && i(null);
			return;
		}
		let { anchor: a } = t, o = a.path[0];
		if (r) {
			pr(e, n, r, i, c, l);
			return;
		}
		if (hr(e, n, i, c, l, o, a)) return;
	} else if (s === "ArrowUp" || s === "ArrowDown") {
		if (r) {
			mr(e, n, r, i);
			return;
		}
		let { selection: t } = e;
		if (t && S.isCollapsed(t)) {
			let { anchor: r } = t, i = r.path[0], a = e.children[i];
			if (_.isElement(a) && a.class !== "text") {
				if (s === "ArrowDown" && i === e.children.length - 1 && dr(e, r, i)) {
					n.preventDefault();
					return;
				}
				if (s === "ArrowUp" && i === 0 && ur(e, r, i)) {
					n.preventDefault();
					return;
				}
			}
		}
	} else if (r && gr(e, n, r, i)) return;
	for (let r of t) if (r.isHotkey(n)) {
		if (r.handler && !r.handler({
			editor: e,
			event: n,
			type: r.plugin.name,
			options: { ...r.plugin.options }
		})) break;
		r.plugin.class === "leaf" ? (n.preventDefault(), sr(e, r.plugin.name)) : r.plugin.class === "text" && (n.preventDefault(), T.setNodes(e, { type: r.plugin.name }, { match: (t) => _.isElement(t) && h.isBlock(e, t) }));
		break;
	}
}
//#endregion
//#region lib/utils/trimWhitespace.ts
var Sr = ({ editor: e }) => {
	let t = [];
	for (let [n, r] of h.nodes(e, {
		at: [],
		match: (e) => _.isElement(e)
	})) {
		if (r.length !== 1) continue;
		let [e, i] = y.first(n, []);
		if (C.isText(e)) {
			let n = e.text.match(/^[\t\n\r\f\v ]+/);
			if (n) {
				let e = [...r, ...i];
				t.push({
					anchor: {
						path: e,
						offset: 0
					},
					focus: {
						path: e,
						offset: n[0].length
					}
				});
			}
		}
		let [a, o] = y.last(n, []);
		if (C.isText(a)) {
			let e = a.text.match(/[\t\n\r\f\v ]+$/);
			if (e) {
				let n = [...r, ...o], i = a.text.length;
				t.push({
					anchor: {
						path: n,
						offset: i - e[0].length
					},
					focus: {
						path: n,
						offset: i
					}
				});
			}
		}
	}
	for (let n of t.reverse()) T.delete(e, { at: n });
};
//#endregion
//#region lib/utils/blockAwarePaste.ts
function Cr(e, t, n, r) {
	if (!n && !r) return "unhandled";
	let i = wr(e, n, r);
	if (i === null) return "unhandled";
	let { targetIndex: a, removeRange: o } = i, s = Tr(t);
	if (s && s.length > 0) {
		h.withoutNormalizing(e, () => {
			if (o) for (let t = o.hi; t >= o.lo; t--) T.removeNodes(e, { at: [t] });
			T.insertNodes(e, s, { at: [a] });
		});
		let t = [a + s.length - 1];
		try {
			T.select(e, h.end(e, t));
		} catch {}
		return "handled";
	}
	return h.withoutNormalizing(e, () => {
		if (o) for (let t = o.hi; t >= o.lo; t--) T.removeNodes(e, { at: [t] });
		let t = {
			id: crypto.randomUUID(),
			type: "core/text",
			class: "text",
			properties: {},
			children: [{ text: "" }]
		};
		T.insertNodes(e, t, {
			at: [a],
			select: !0
		});
	}), "prepared";
}
function wr(e, t, n) {
	if (n) {
		let t = Math.min(n.anchorIndex, n.focusIndex), r = Math.max(n.anchorIndex, n.focusIndex);
		return t < 0 || r >= e.children.length ? null : {
			targetIndex: t,
			removeRange: {
				lo: t,
				hi: r
			}
		};
	}
	if (t) {
		let n = e.children.findIndex((e) => _.isElement(e) && e.id === t.blockId);
		return n === -1 ? null : {
			targetIndex: t.direction === "before" ? n : n + 1,
			removeRange: null
		};
	}
	return null;
}
function Tr(e) {
	if (!e.types.includes("application/x-slate-fragment")) return null;
	let t = e.getData("application/x-slate-fragment");
	if (!t) return null;
	try {
		let e = decodeURIComponent(window.atob(t)), n = JSON.parse(e);
		return Array.isArray(n) ? n : null;
	} catch {
		return null;
	}
}
//#endregion
//#region lib/components/TextbitEditable/TextbitEditable.tsx
function Er(e) {
	let t = M(), { placeholders: n, placeholder: i, readOnly: o, dir: s, collaborative: c, verbose: m } = G(), { components: g, actions: v } = W(), b = re(), x = Jn(), [ee, te] = u(/* @__PURE__ */ new Map()), [C, w] = u(null), [E, O] = u(null), { onFocus: k, onBlur: A, constraints: j, autoFocus: N = !1, isSpellingAccepted: P } = e;
	a(() => {
		t.allowEdgeWhitespace = j?.allowEdgeWhitespace !== !1;
	}, [t, j?.allowEdgeWhitespace]);
	let F = l(!0);
	a(() => (F.current = !0, () => {
		F.current = !1;
	}), []);
	let I = l(!1), ae = r((e) => {
		let n = I.current;
		I.current = !1, queueMicrotask(() => {
			n || t.selection || T.select(t, N === "end" ? h.end(t, []) : h.start(t, []));
		}), k?.(e);
	}, [
		t,
		N,
		k
	]);
	a(() => {
		typeof t.onSpellcheckComplete == "function" && t.onSpellcheckComplete((e) => {
			F.current && te(e);
		});
	}, [t]);
	let oe = r((e) => Bn({ ...e }), []), se = r((e) => Vn(e), []), ce = ie((e) => e.children.every((e) => y.string(e) === "")), le = r((e) => ln(t, ee, e, g, n, i, ce, P), [
		t,
		g,
		n,
		i,
		ee,
		ce,
		P
	]), ue = r((e) => {
		if (j?.allowEdgeWhitespace !== !1) {
			A?.(e);
			return;
		}
		queueMicrotask(() => {
			Sr({ editor: t });
		}), A?.(e);
	}, [
		t,
		j,
		A
	]), de = r((e) => {
		xr(t, v, e, C, w, E, O);
	}, [
		t,
		v,
		C,
		w,
		E,
		O
	]), L = r((e) => {
		if (!C && !E) return;
		let n = e.clipboardData;
		if (!n) return;
		let r = Cr(t, n, C, E);
		r !== "unhandled" && (C && w(null), E && O(null), r === "handled" && e.preventDefault());
	}, [
		t,
		C,
		E,
		w,
		O
	]), fe = r((e) => {
		I.current = !0;
		let n = e.clientX, r = e.clientY;
		for (let i = 0; i < t.children.length; i++) {
			let a = t.children[i];
			if (!_.isElement(a) || a.class === "text") continue;
			let o;
			try {
				o = D.toDOMNode(t, a);
			} catch {
				continue;
			}
			let s = o.getBoundingClientRect();
			if (r < s.top || r > s.bottom || n >= s.left && n <= s.right) continue;
			e.preventDefault(), D.focus(t);
			let c = n < (s.left + s.right) / 2 ? "before" : "after";
			c === "before" ? T.select(t, h.start(t, [i])) : T.select(t, h.end(t, [i])), w({
				blockId: a.id,
				direction: c
			}), E && O(null);
			return;
		}
		if (C && w(null), E && O(null), navigator.userAgent.includes("Gecko/") && !b) {
			let n = D.findEventRange(t, e);
			S.isRange(n) && T.select(t, n);
		}
	}, [
		t,
		b,
		C,
		w,
		E,
		O
	]);
	return /* @__PURE__ */ p(d, { children: [/* @__PURE__ */ f(ar, {
		value: E,
		children: /* @__PURE__ */ f(ir, {
			value: C,
			children: /* @__PURE__ */ f(Xn, { children: /* @__PURE__ */ f(nr, {
				isCollaborative: c,
				children: /* @__PURE__ */ p(Qn, {
					editor: t,
					children: [/* @__PURE__ */ f(ne, {
						autoFocus: !!N,
						"data-state": b ? "focused" : "",
						readOnly: o,
						renderElement: oe,
						renderLeaf: se,
						onFocus: ae,
						onBlur: ue,
						onKeyDown: de,
						onPaste: L,
						decorate: le,
						className: e.className,
						style: C || E ? {
							...e.style,
							caretColor: "transparent"
						} : e.style,
						spellCheck: !1,
						dir: s,
						onContextMenu: x,
						onMouseDown: fe,
						"aria-label": e["aria-label"]
					}), e.children]
				})
			}) })
		})
	}), m && /* @__PURE__ */ f(rr, {})] });
}
//#endregion
//#region lib/components/GutterProvider/Content.tsx
function Dr({ children: e, style: t, className: n }) {
	return /* @__PURE__ */ f("div", {
		style: t,
		className: n,
		children: e
	});
}
//#endregion
//#region lib/components/GutterProvider/index.tsx
var Or = {
	Provider: rn,
	Content: Dr
};
//#endregion
//#region lib/components/DropMarker.tsx
function kr({ className: e, style: t = {} }) {
	let n = l(null), { offset: r, dragOver: a } = i(dn), [s, c] = u(null);
	o(() => {
		if (!n.current || !a) return;
		let e = n.current.parentElement;
		if (!e) return;
		let t = Ar(e);
		t && c(t.getBoundingClientRect());
	}, [a, r]);
	let d = {
		height: "3px",
		backgroundColor: "rgb(191, 191, 191)",
		borderRadius: "2px"
	}, p = { display: "none" };
	if (a && r && s) {
		let { bbox: e, position: t } = r;
		if (!e) return null;
		let n = e.left - s.left, i = e.top - s.top;
		p.display = "block", p.left = n, p.width = e.width, t?.[1] ? (p.top = i, p.height = e.height + 2, p.backgroundColor = "rgba(191, 191, 191, 0.4)", p.borderRadius = "4px") : p.top = t?.[0] === "above" ? i - 2 : i + e.height - 2;
	}
	let m = a ? r?.position?.[1] ? "around" : "between" : "none";
	return /* @__PURE__ */ f("div", {
		ref: n,
		className: e,
		"data-dragover": m,
		style: {
			pointerEvents: "none",
			position: "absolute",
			margin: 0,
			userSelect: "none",
			...d,
			...p,
			...t
		}
	});
}
function Ar(e) {
	let t = e;
	for (; t;) {
		if (getComputedStyle(t).position !== "static") return t;
		t = t.parentElement;
	}
	return null;
}
//#endregion
//#region lib/hooks/usePendingDrops.tsx
function jr() {
	return i(Zn)?.drops ?? [];
}
//#endregion
//#region lib/components/UploadMarker.tsx
var Mr = 60;
function Nr({ className: e, style: t, height: n = Mr, children: r }) {
	let i = M(), s = jr(), c = l(null), [d, m] = u(null);
	o(() => {
		if (s.length === 0) return;
		let e = [];
		for (let t of s) {
			let r = Rr(i, t.path);
			if (!r) continue;
			let a = r.style.marginTop;
			r.style.marginTop = `${n}px`, e.push(() => {
				r.style.marginTop = a;
			});
		}
		return () => {
			for (let t of e) t();
		};
	}, [
		s,
		i,
		n
	]), o(() => {
		if (!c.current) return;
		let e = c.current.parentElement;
		if (!e) return;
		let t = Lr(e);
		if (!t) return;
		let n = () => m(t.getBoundingClientRect());
		if (n(), s.length === 0) return;
		let r = new ResizeObserver(n);
		r.observe(t);
		let a = Array.from(e.children).find((e) => e.getAttribute("role") === "textbox");
		a && r.observe(a);
		for (let e of s) {
			let t = Rr(i, e.path);
			t && r.observe(t);
		}
		return window.addEventListener("scroll", n, {
			passive: !0,
			capture: !0
		}), window.addEventListener("resize", n, { passive: !0 }), () => {
			r.disconnect(), window.removeEventListener("scroll", n, { capture: !0 }), window.removeEventListener("resize", n);
		};
	}, [s, i]);
	let h = s.filter((e) => e.source === "own").length, [g, _] = u("");
	return a(() => {
		if (h === 0) {
			_("");
			return;
		}
		_(h === 1 ? "Upload in progress" : `${h} uploads in progress`);
	}, [h]), s.length === 0 || !d ? /* @__PURE__ */ f("div", {
		ref: c,
		style: { display: "none" },
		children: /* @__PURE__ */ f(Pr, { text: g })
	}) : /* @__PURE__ */ p("div", {
		ref: c,
		style: { display: "contents" },
		children: [/* @__PURE__ */ f(Pr, { text: g }), s.map((a) => {
			let o = zr(i, a.path);
			if (!o) return null;
			let s = {
				position: "absolute",
				left: o.left - d.left,
				top: o.top - d.top - n,
				width: o.width,
				height: n,
				pointerEvents: "none",
				userSelect: "none"
			};
			return /* @__PURE__ */ f("div", {
				className: e,
				"data-source": a.source,
				"data-kind": a.kind ?? "",
				style: {
					...Ir,
					...s,
					...t
				},
				children: r ? r(a) : null
			}, a.id);
		})]
	});
}
function Pr({ text: e }) {
	return /* @__PURE__ */ f("div", {
		role: "status",
		"aria-live": "polite",
		"aria-atomic": "true",
		style: Fr,
		children: e
	});
}
var Fr = {
	position: "absolute",
	width: 1,
	height: 1,
	padding: 0,
	margin: -1,
	overflow: "hidden",
	clip: "rect(0, 0, 0, 0)",
	whiteSpace: "nowrap",
	border: 0
}, Ir = {
	background: "rgba(191, 191, 191, 0.25)",
	border: "1px dashed rgba(128, 128, 128, 0.6)",
	borderRadius: 2
};
function Lr(e) {
	let t = e;
	for (; t;) {
		if (getComputedStyle(t).position !== "static") return t;
		t = t.parentElement;
	}
	return null;
}
function Rr(e, t) {
	try {
		let [n] = e.node(t);
		return D.toDOMNode(e, n);
	} catch {
		return null;
	}
}
function zr(e, t) {
	let n = Rr(e, t);
	return n ? n.getBoundingClientRect() : null;
}
//#endregion
//#region lib/hooks/useSelectionBounds.tsx
var X = () => {
	let e = i(Ke);
	if (!e) throw Error("useTextbitSelectionBoundsState must be used within a TextbitSelectionBoundsProvider");
	let [t, n] = u(e.boundsRef.current);
	return a(() => e.subscribe(n), [e]), t;
};
//#endregion
//#region lib/components/ContextTools/Menu.tsx
function Br({ children: e, className: t }) {
	return L(/* @__PURE__ */ f(Vr, {
		className: t,
		children: e
	}), document.body);
}
function Vr({ children: e, className: t }) {
	let n = M(), o = X(), s = re(), c = K(), u = l(null), d = i(H)?.menu != null, p = r((e) => {
		let t = u.current;
		t && (t.style.opacity = e ? "1" : "0", t.style.pointerEvents = e ? "auto" : "none");
	}, []);
	a(() => {
		if (!s) return;
		let e = !1;
		o?.isCollapsed ? n.selection && (e = !!h.nodes(n, {
			at: n.selection,
			match: (e) => z.isElement(e) && e.class === "inline"
		}).next().value) : e = !0, p(!!(e && !d && !c));
	}, [
		n,
		o,
		s,
		p,
		d,
		c
	]);
	let m = r((e) => {
		if (!s) return;
		let t = u.current;
		if (!t || !e || e.left <= 0 || e.top <= 0) return;
		let n = t.getBoundingClientRect(), r = e.left + e.width / 2 - n.width / 2, i = e.top - n.height - 8, a = window.innerWidth - n.width - 8;
		r = Math.max(8, Math.min(r, a)), i < 8 && (i = e.top + e.height + 8);
		let o = window.innerHeight - n.height - 8;
		i > o && (i = e.top - n.height - 8, i = Math.min(i, o)), t.style.transform = `translate(${r}px, ${i}px)`;
	}, [s]);
	return a(() => {
		o ? requestAnimationFrame(() => m(o)) : p(!1);
	}, [
		m,
		o,
		p
	]), a(() => {
		let e = u.current;
		if (!e) return;
		let t = new ResizeObserver(() => {
			o && requestAnimationFrame(() => m(o));
		});
		return t.observe(e), () => {
			t.disconnect();
		};
	}, [m, o]), /* @__PURE__ */ f("div", {
		ref: u,
		className: t,
		style: {
			position: "fixed",
			top: 0,
			left: 0,
			opacity: 0,
			pointerEvents: "none",
			willChange: "transform",
			zIndex: 9701
		},
		children: e
	});
}
//#endregion
//#region lib/components/ContextTools/Group.tsx
function Hr({ children: n, className: i }) {
	let a = M(), o = j(), s = h.nodes(a, { mode: "lowest" }).next().value || void 0, c = r((n) => !s || !o ? n : t.toArray(n).filter((t) => S.isCollapsed(o) ? e.isValidElement(t) ? t.props?.action?.plugin?.class === "inline" : !1 : !0), [s, o])(n), l = t.count(c) > 0;
	return /* @__PURE__ */ f(d, { children: l ? /* @__PURE__ */ f("div", {
		className: i || "",
		children: n
	}) : /* @__PURE__ */ f(d, {}) });
}
//#endregion
//#region lib/components/ContextTools/Item.tsx
function Ur({ action: e, className: n, children: r }) {
	let i = M(), a = j(), o = or(i, e.plugin.name), s = h.nodes(i, { mode: "lowest" }).next().value || void 0, c = Array.from(h.nodes(i, {
		match: (t) => z.isElement(t) && t.class === "inline" && t.type === e.plugin.name,
		at: a ?? void 0
	})), l = Array.isArray(e.tool) ? e.tool.length === 2 && c.length === 1 ? e.tool[1] : e.tool[0] : e.tool;
	if (l) {
		if (c.length === 1) {
			let e = c[0];
			return /* @__PURE__ */ p("div", {
				"data-state": "active",
				children: [t.count(r) ? /* @__PURE__ */ f(l, {
					editor: i,
					active: o,
					entry: e,
					children: r
				}) : /* @__PURE__ */ f(l, {
					editor: i,
					active: o,
					entry: e
				}), /* @__PURE__ */ f("em", { className: "active" })]
			});
		}
		return /* @__PURE__ */ f("div", {
			"data-state": o ? "active" : "inactive",
			className: n || "",
			onMouseDown: (t) => {
				c.length > 1 || (e.handler({
					editor: i,
					event: t,
					type: e.plugin.name,
					options: { ...e.plugin.options }
				}) && sr(i, e.plugin.name), t.defaultPrevented || t.preventDefault());
			},
			children: /* @__PURE__ */ f(l, {
				editor: i,
				active: o,
				entry: s,
				children: r
			})
		});
	}
}
//#endregion
//#region lib/components/ContextTools/index.tsx
var Wr = {
	Menu: Br,
	Group: Hr,
	Item: Ur
}, Gr = n([!1, () => {}]);
//#endregion
//#region lib/components/ContentTools/Menu.tsx
function Kr({ children: e, className: t, style: n = {} }) {
	let [r, i] = u(!1), s = l(null), c = X(), d = re(), { readOnly: p } = G();
	return o(() => {
		let e = s.current;
		if (!e || !c || p || !d) return;
		let t = e.offsetParent;
		if (!t) return;
		let n = t.getBoundingClientRect(), r = (c.box?.top ?? c.top) - n.top;
		e.style.top = `${r}px`;
	}, [
		c,
		p,
		d
	]), a(() => {
		i((e) => d ? e : !1);
	}, [d]), p || !d || !c ? null : /* @__PURE__ */ f(Gr.Provider, {
		value: [r, i],
		children: /* @__PURE__ */ f("div", {
			ref: s,
			className: t,
			"data-state": r ? "open" : "closed",
			style: {
				position: "absolute",
				top: 0,
				zIndex: 9909,
				...n
			},
			children: e
		})
	});
}
//#endregion
//#region lib/hooks/useClickGlobal.tsx
function qr(e) {
	let t = l(null), n = l(e);
	return o(() => {
		n.current = e;
	}), a(() => {
		let e = (e) => {
			(t?.current)?.contains(e.target) || n.current(e);
		};
		return document.addEventListener("mousedown", e), document.addEventListener("touchstart", e), () => {
			document.removeEventListener("mousedown", e), document.removeEventListener("touchstart", e);
		};
	}, []), t;
}
//#endregion
//#region lib/components/ContentTools/Trigger.tsx
function Jr({ children: e, className: t }) {
	let [n, r] = i(Gr), { triggerRef: o, updateTriggerRef: s } = i(nn), c = qr(() => {
		r(!1);
	});
	return a(() => {
		o && c.current && s(c.current);
	}, [
		o,
		s,
		c
	]), /* @__PURE__ */ f("a", {
		ref: c,
		className: t,
		onMouseDown: (e) => {
			e.preventDefault(), r(!n);
		},
		children: e
	});
}
//#endregion
//#region lib/hooks/useKeydownGlobal.tsx
function Yr(e) {
	let t = l(null), n = l(e);
	return o(() => {
		n.current = e;
	}), a(() => {
		let e = (e) => {
			(t?.current)?.contains(e.target) || n.current(e);
		};
		return document.addEventListener("keydown", e, { capture: !0 }), () => {
			document.removeEventListener("keydown", e, { capture: !0 });
		};
	}, []), t;
}
//#endregion
//#region lib/components/ContentTools/Content.tsx
function Xr({ children: e, className: t }) {
	let [n, r] = i(Gr), a = Yr((e) => {
		n && (e.key === "Escape" || e.key === "Tab") && (e.preventDefault(), r(!1));
	});
	return /* @__PURE__ */ f("div", {
		ref: a,
		children: n && /* @__PURE__ */ f(Zr, {
			className: t,
			children: e
		})
	});
}
function Zr({ children: e, className: t }) {
	let { triggerRef: n } = i(nn), r = l(null);
	return o(() => {
		let e = r.current, t = n?.current;
		if (!t || !e) return;
		let i = t.getBoundingClientRect(), a = e.getBoundingClientRect(), o = i.right + 8, s = i.top, c = window.innerWidth - a.width - 8;
		o = Math.min(o, c), s + a.height > window.innerHeight - 8 && (s = Math.max(8, window.innerHeight - a.height - 8)), e.style.transform = `translate(${o}px, ${s}px)`;
	}, [n]), /* @__PURE__ */ f("div", {
		ref: r,
		className: t,
		style: {
			position: "fixed",
			top: 0,
			left: 0,
			willChange: "transform"
		},
		children: e
	});
}
//#endregion
//#region lib/components/ContentTools/Group.tsx
function Qr({ children: e, className: n }) {
	let r = t.count(e) > 0;
	return /* @__PURE__ */ f(d, { children: r ? /* @__PURE__ */ f("div", {
		className: n,
		children: e
	}) : /* @__PURE__ */ f(d, {}) });
}
//#endregion
//#region lib/components/ContentTools/ItemContext.tsx
var Z = n({ isActive: !1 });
//#endregion
//#region lib/components/ContentTools/Item.tsx
function $r({ children: e, className: t, action: n }) {
	let { plugins: r, actions: i } = W(), a = M(), o = j(), s = i.find((e) => e.name === n);
	if (!s) return /* @__PURE__ */ f(d, {});
	let [c, , l] = ei(a, o, s) || [
		!1,
		!1,
		!1
	];
	return c ? /* @__PURE__ */ f(Z.Provider, {
		value: {
			isActive: !!l,
			action: s
		},
		children: /* @__PURE__ */ f("a", {
			className: t,
			"data-state": l ? "active" : "inactive",
			onMouseDown: (e) => {
				e.preventDefault(), s.handler({
					editor: a,
					type: s.plugin.name,
					options: s.plugin.options,
					api: { consumeFileInputChangeEvent: (e, t) => {
						fn(e, r, t);
					} }
				});
			},
			children: e
		})
	}) : /* @__PURE__ */ f(d, {});
}
function ei(e, t, n) {
	if (!t) return [
		!1,
		!1,
		!1
	];
	let r = Array.from(h.nodes(e, {
		at: h.unhangRange(e, t),
		match: (e) => !h.isEditor(e) && _.isElement(e)
	}));
	if (!r.length || !n?.visibility) return [
		!1,
		!1,
		!1
	];
	let i = r[0][0], a = r[r.length - 1][0];
	if (!z.isElement(i)) return [
		!1,
		!1,
		!1
	];
	let o = z.isElement(a) ? a : void 0;
	return n?.visibility(i, o) || [[
		!1,
		!1,
		!1
	]];
}
//#endregion
//#region lib/components/ContentTools/Icon.tsx
function ti({ children: e, className: n }) {
	let r = M(), { isActive: a, action: o } = i(Z), s = Array.isArray(o?.tool) ? o.tool[0] || null : o?.tool || null;
	return s && !t.count(e) ? /* @__PURE__ */ p("div", {
		className: n,
		children: [a && "✓", !a && s && /* @__PURE__ */ f(s, { editor: r })]
	}) : /* @__PURE__ */ f("div", {
		className: n,
		children: e
	});
}
//#endregion
//#region lib/components/ContentTools/Hotkey.tsx
function ni({ className: e, children: n }) {
	let { action: r } = i(Z);
	return /* @__PURE__ */ f("div", {
		className: e,
		children: t.count(n) ? n : Re(r?.hotkey || "")
	});
}
//#endregion
//#region lib/components/ContentTools/Label.tsx
function ri({ children: e, className: n }) {
	let { action: r } = i(Z);
	return /* @__PURE__ */ f("div", {
		className: n,
		children: t.count(e) ? e : r?.title || ""
	});
}
//#endregion
//#region lib/components/ContentTools/index.tsx
var Q = {
	Menu: Kr,
	Trigger: Jr,
	Content: Xr,
	Group: Qr,
	Item: $r,
	Icon: ti,
	Hotkey: ni,
	Label: ri
};
//#endregion
//#region lib/components/ContextMenu/useContextMenuHints.tsx
function ii() {
	let e = i(H);
	if (e === void 0) throw Error("useContextMenu must be used within a ContextMenuContextProvider");
	return {
		menu: e.menu,
		spelling: e.spelling
	};
}
//#endregion
//#region lib/components/ContextMenu/Menu.tsx
var $ = 8;
function ai({ children: e, className: t }) {
	return L(/* @__PURE__ */ f(oi, {
		className: t,
		children: e
	}), document.body);
}
function oi({ children: e, className: t }) {
	let { readOnly: n } = G(), o = i(H), s = l(null), { menu: c } = ii(), u = r(() => {
		let e = s.current;
		if (!e || !c?.position) return;
		let t = e.getBoundingClientRect(), { x: n, y: r } = c.position, i = n, a = r + $, o = window.innerWidth - t.width - $;
		i = Math.max($, Math.min(i, o)), a + t.height > window.innerHeight - $ && (a = r - t.height - $), a = Math.max($, a), e.style.transform = `translate(${i}px, ${a}px)`;
	}, [c?.position]);
	return a(() => {
		if (!c?.position || n) return;
		let e = (e) => {
			s.current?.contains(e.target) || o?.dispatch({
				menu: void 0,
				spelling: void 0
			});
		};
		return window.addEventListener("pointerdown", e, { capture: !0 }), window.addEventListener("keydown", e, { capture: !0 }), () => {
			window.removeEventListener("pointerdown", e, { capture: !0 }), window.removeEventListener("keydown", e, { capture: !0 });
		};
	}, [
		n,
		c?.position,
		o
	]), a(() => {
		let e = s.current;
		if (!e || n || !c?.position) return;
		requestAnimationFrame(u);
		let t = new ResizeObserver(() => {
			requestAnimationFrame(u);
		});
		return t.observe(e), () => {
			t.disconnect();
		};
	}, [
		n,
		c?.position,
		u
	]), !c?.position || n ? null : /* @__PURE__ */ f("div", {
		ref: s,
		className: t,
		style: {
			position: "fixed",
			top: 0,
			left: 0,
			maxHeight: "calc(100vh - 16px)",
			overflowY: "auto",
			willChange: "transform",
			pointerEvents: "auto",
			zIndex: 9702
		},
		children: e
	});
}
//#endregion
//#region lib/components/ContextMenu/Group.tsx
function si({ children: e, className: n }) {
	return /* @__PURE__ */ f(d, { children: t.count(e) > 0 && /* @__PURE__ */ f("div", {
		className: n,
		children: e
	}) });
}
//#endregion
//#region lib/components/ContextMenu/Item.tsx
function ci({ children: e, className: n, func: r = void 0 }) {
	let a = M(), o = i(H);
	return t.count(e) ? /* @__PURE__ */ f("a", {
		className: n,
		onMouseDown: (e) => {
			e.preventDefault(), r && r(a), o?.dispatch({
				menu: void 0,
				spelling: void 0
			});
		},
		children: e
	}) : /* @__PURE__ */ f(d, {});
}
//#endregion
//#region lib/components/ContextMenu/index.tsx
var li = {
	Root: ai,
	Group: si,
	Item: ci
};
//#endregion
//#region lib/hooks/useAction.tsx
function ui(e, t) {
	let n = M(), { actions: r } = W(), i = `${e}/${t}`, a = r.find((e) => e.name === i);
	if (a) return (t) => {
		a.handler({
			editor: n,
			type: e,
			options: a.plugin.options,
			args: t
		});
	};
}
//#endregion
//#region lib/hooks/useEditor.tsx
function di() {
	return M();
}
//#endregion
//#region lib/hooks/useSelectionStats.tsx
var fi = {
	words: 0,
	characters: 0,
	charactersNoSpaces: 0
}, pi = () => ie((e) => {
	let { selection: t } = e;
	if (!t || S.isCollapsed(t)) return fi;
	let [n, r] = S.edges(t), i = 0, a = 0, o = 0;
	for (let [s, c] of h.nodes(e, {
		at: t,
		match: C.isText,
		voids: !0
	})) {
		let e = s.text;
		b.equals(c, r.path) && (e = e.slice(0, r.offset)), b.equals(c, n.path) && (e = e.slice(n.offset)), a += e.length, o += (e.match(/\S/gu) || []).length, i += (e.match(/\p{L}+/gu) || []).length;
	}
	return {
		words: i,
		characters: a,
		charactersNoSpaces: o
	};
}, mi);
function mi(e, t) {
	return e !== null && e.words === t.words && e.characters === t.characters && e.charactersNoSpaces === t.charactersNoSpaces;
}
//#endregion
//#region lib/main.ts
var hi = {
	Root: an,
	Editable: Er,
	Gutter: Or.Content,
	DropMarker: kr,
	UploadMarker: Nr,
	Plugins: V,
	ContextMenu: li
}, gi = {
	Root: Q.Menu,
	Trigger: Q.Trigger,
	Content: Q.Content,
	Group: Q.Group,
	Item: Q.Item,
	Icon: Q.Icon,
	Label: Q.Label,
	Hotkey: Q.Hotkey
}, _i = {
	Root: Wr.Menu,
	Group: Wr.Group,
	Item: Wr.Item
}, vi = Or.Content;
//#endregion
export { li as ContextMenu, kr as DropMarker, Er as Editable, m as Editor, g as Element, vi as Gutter, gi as Menu, v as Node, Zn as PendingDropsContext, V as Plugins, ee as Range, an as Root, te as Text, hi as Textbit, B as TextbitEditor, z as TextbitElement, R as TextbitPlugin, _i as Toolbar, w as Transforms, Nr as UploadMarker, Je as calculateStats, pn as consumeFileDropEvent, fn as consumeFileInputChangeEvent, Ne as isMac, ui as useAction, K as useBlockSelection, ii as useContextMenuHints, di as useEditor, jr as usePendingDrops, W as usePluginRegistry, X as useSelectionBounds, pi as useSelectionStats, G as useTextbit };
